export const PFDuos = [
  {
    char: 'the-herta',
    app: 71.67,
    char_1: 'herta',
    app_rate_1: '61.24%',
    avg_round_1: 39104,
    app_flat_1: 4000,
    char_2: 'tribbie',
    app_rate_2: '48.53%',
    avg_round_2: 40000,
    app_flat_2: 2807,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '34.28%',
    avg_round_3: 38553,
    app_flat_3: 2465,
    char_4: 'aventurine',
    app_rate_4: '25.27%',
    avg_round_4: 39042,
    app_flat_4: 1627,
    char_5: 'jade',
    app_rate_5: '25.18%',
    avg_round_5: 39947,
    app_flat_5: 1383,
    char_6: 'lingsha',
    app_rate_6: '20.32%',
    avg_round_6: 39625,
    app_flat_6: 1256,
    char_7: 'robin',
    app_rate_7: '15.5%',
    avg_round_7: 38071,
    app_flat_7: 794,
    char_8: 'huohuo',
    app_rate_8: '14.66%',
    avg_round_8: 39503,
    app_flat_8: 873,
    char_9: 'serval',
    app_rate_9: '9.42%',
    avg_round_9: 38676,
    app_flat_9: 516,
    char_10: 'gallagher',
    app_rate_10: '9.05%',
    avg_round_10: 39006,
    app_flat_10: 672,
    char_11: 'fu-xuan',
    app_rate_11: '8.37%',
    avg_round_11: 39077,
    app_flat_11: 424,
    char_12: 'ruan-mei',
    app_rate_12: '6.96%',
    avg_round_12: 37670,
    app_flat_12: 379,
    char_13: 'sunday',
    app_rate_13: '6.83%',
    avg_round_13: 36741,
    app_flat_13: 388,
    char_14: 'luocha',
    app_rate_14: '5.28%',
    avg_round_14: 35872,
    app_flat_14: 334,
    char_15: 'argenti',
    app_rate_15: '2.54%',
    avg_round_15: 39754,
    app_flat_15: 134,
    char_16: 'sparkle',
    app_rate_16: '2.04%',
    avg_round_16: 34841,
    app_flat_16: 69,
    char_17: 'himeko',
    app_rate_17: '1.94%',
    avg_round_17: 34265,
    app_flat_17: 116,
    char_18: 'rappa',
    app_rate_18: '0.35%',
    avg_round_18: 35400,
    app_flat_18: 14,
    char_19: 'pela',
    app_rate_19: '0.35%',
    avg_round_19: 35650,
    app_flat_19: 20,
    char_20: 'tingyun-fugue',
    app_rate_20: '0.29%',
    avg_round_20: 32083,
    app_flat_20: 15,
    char_21: 'bailu',
    app_rate_21: '0.23%',
    avg_round_21: 37996,
    app_flat_21: 9,
    char_22: 'jiaoqiu',
    app_rate_22: '0.18%',
    avg_round_22: 33930,
    app_flat_22: 4,
    char_23: 'bronya',
    app_rate_23: '0.15%',
    avg_round_23: 30800,
    app_flat_23: 2,
    char_24: 'lynx',
    app_rate_24: '0.13%',
    avg_round_24: 38504,
    app_flat_24: 7,
    char_25: 'tingyun',
    app_rate_25: '0.12%',
    avg_round_25: 36407,
    app_flat_25: 6,
    char_26: 'jing-yuan',
    app_rate_26: '0.09%',
    avg_round_26: 35800,
    app_flat_26: 3,
    char_27: 'gepard',
    app_rate_27: '0.08%',
    avg_round_27: 31008,
    app_flat_27: 5,
    char_28: 'march-7th',
    app_rate_28: '0.08%',
    avg_round_28: 35352,
    app_flat_28: 5,
    char_29: 'acheron',
    app_rate_29: '0.08%',
    avg_round_29: 30440,
    app_flat_29: 1,
    char_30: 'yunli',
    app_rate_30: '0.07%',
    avg_round_30: 31800,
    app_flat_30: 4
  },
  {
    char: 'tribbie',
    app: 64.84,
    char_1: 'the-herta',
    app_rate_1: '53.65%',
    avg_round_1: 40000,
    app_flat_1: 2807,
    char_2: 'herta',
    app_rate_2: '36.31%',
    avg_round_2: 39999,
    app_flat_2: 1939,
    char_3: 'aventurine',
    app_rate_3: '22.21%',
    avg_round_3: 39828,
    app_flat_3: 1058,
    char_4: 'jade',
    app_rate_4: '21.29%',
    avg_round_4: 40000,
    app_flat_4: 971,
    char_5: 'huohuo',
    app_rate_5: '17.12%',
    avg_round_5: 39161,
    app_flat_5: 777,
    char_6: 'lingsha',
    app_rate_6: '15.75%',
    avg_round_6: 40000,
    app_flat_6: 735,
    char_7: 'sunday',
    app_rate_7: '15.46%',
    avg_round_7: 35250,
    app_flat_7: 550,
    char_8: 'fu-xuan',
    app_rate_8: '13.38%',
    avg_round_8: 38766,
    app_flat_8: 473,
    char_9: 'acheron',
    app_rate_9: '12.65%',
    avg_round_9: 35805,
    app_flat_9: 340,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '10.96%',
    avg_round_10: 39662,
    app_flat_10: 547,
    char_11: 'robin',
    app_rate_11: '9.43%',
    avg_round_11: 37205,
    app_flat_11: 310,
    char_12: 'gallagher',
    app_rate_12: '8.0%',
    avg_round_12: 39615,
    app_flat_12: 425,
    char_13: 'serval',
    app_rate_13: '7.79%',
    avg_round_13: 39597,
    app_flat_13: 392,
    char_14: 'jiaoqiu',
    app_rate_14: '6.16%',
    avg_round_14: 39190,
    app_flat_14: 168,
    char_15: 'aglaea',
    app_rate_15: '6.14%',
    avg_round_15: 35373,
    app_flat_15: 253,
    char_16: 'jing-yuan',
    app_rate_16: '5.11%',
    avg_round_16: 33956,
    app_flat_16: 187,
    char_17: 'pela',
    app_rate_17: '4.68%',
    avg_round_17: 34361,
    app_flat_17: 140,
    char_18: 'luocha',
    app_rate_18: '4.22%',
    avg_round_18: 38533,
    app_flat_18: 199,
    char_19: 'argenti',
    app_rate_19: '3.77%',
    avg_round_19: 39636,
    app_flat_19: 174,
    char_20: 'sparkle',
    app_rate_20: '3.57%',
    avg_round_20: 32267,
    app_flat_20: 70,
    char_21: 'yunli',
    app_rate_21: '3.5%',
    avg_round_21: 36996,
    app_flat_21: 125,
    char_22: 'ruan-mei',
    app_rate_22: '3.44%',
    avg_round_22: 37803,
    app_flat_22: 116,
    char_23: 'himeko',
    app_rate_23: '2.08%',
    avg_round_23: 34472,
    app_flat_23: 94,
    char_24: 'mydei',
    app_rate_24: '2.07%',
    avg_round_24: 31650,
    app_flat_24: 59,
    char_25: 'kafka',
    app_rate_25: '1.55%',
    avg_round_25: 30695,
    app_flat_25: 34,
    char_26: 'tingyun-fugue',
    app_rate_26: '1.42%',
    avg_round_26: 34232,
    app_flat_26: 35,
    char_27: 'feixiao',
    app_rate_27: '1.41%',
    avg_round_27: 33555,
    app_flat_27: 42,
    char_28: 'bronya',
    app_rate_28: '0.79%',
    avg_round_28: 30141,
    app_flat_28: 23,
    char_29: 'black-swan',
    app_rate_29: '0.68%',
    avg_round_29: 28499,
    app_flat_29: 15,
    char_30: 'clara',
    app_rate_30: '0.68%',
    avg_round_30: 31381,
    app_flat_30: 23
  },
  {
    char: 'herta',
    app: 61.26,
    char_1: 'the-herta',
    app_rate_1: '71.65%',
    avg_round_1: 39104,
    app_flat_1: 4000,
    char_2: 'tribbie',
    app_rate_2: '38.43%',
    avg_round_2: 39999,
    app_flat_2: 1939,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '36.25%',
    avg_round_3: 37728,
    app_flat_3: 2206,
    char_4: 'aventurine',
    app_rate_4: '26.57%',
    avg_round_4: 37669,
    app_flat_4: 1373,
    char_5: 'robin',
    app_rate_5: '25.82%',
    avg_round_5: 33497,
    app_flat_5: 1071,
    char_6: 'ruan-mei',
    app_rate_6: '15.15%',
    avg_round_6: 32517,
    app_flat_6: 678,
    char_7: 'lingsha',
    app_rate_7: '13.84%',
    avg_round_7: 38927,
    app_flat_7: 769,
    char_8: 'huohuo',
    app_rate_8: '11.02%',
    avg_round_8: 38870,
    app_flat_8: 579,
    char_9: 'gallagher',
    app_rate_9: '8.72%',
    avg_round_9: 38490,
    app_flat_9: 537,
    char_10: 'jade',
    app_rate_10: '7.97%',
    avg_round_10: 36502,
    app_flat_10: 365,
    char_11: 'fu-xuan',
    app_rate_11: '7.4%',
    avg_round_11: 37890,
    app_flat_11: 302,
    char_12: 'sunday',
    app_rate_12: '7.36%',
    avg_round_12: 33942,
    app_flat_12: 354,
    char_13: 'himeko',
    app_rate_13: '6.31%',
    avg_round_13: 27841,
    app_flat_13: 290,
    char_14: 'luocha',
    app_rate_14: '4.93%',
    avg_round_14: 34221,
    app_flat_14: 271,
    char_15: 'tingyun-fugue',
    app_rate_15: '3.27%',
    avg_round_15: 29085,
    app_flat_15: 133,
    char_16: 'sparkle',
    app_rate_16: '3.24%',
    avg_round_16: 31224,
    app_flat_16: 94,
    char_17: 'feixiao',
    app_rate_17: '2.27%',
    avg_round_17: 29157,
    app_flat_17: 66,
    char_18: 'trailblazer-harmony',
    app_rate_18: '1.01%',
    avg_round_18: 29269,
    app_flat_18: 38,
    char_19: 'rappa',
    app_rate_19: '0.95%',
    avg_round_19: 30477,
    app_flat_19: 51,
    char_20: 'yunli',
    app_rate_20: '0.76%',
    avg_round_20: 30793,
    app_flat_20: 27,
    char_21: 'argenti',
    app_rate_21: '0.7%',
    avg_round_21: 30969,
    app_flat_21: 36,
    char_22: 'pela',
    app_rate_22: '0.7%',
    avg_round_22: 32813,
    app_flat_22: 35,
    char_23: 'tingyun',
    app_rate_23: '0.6%',
    avg_round_23: 29811,
    app_flat_23: 33,
    char_24: 'firefly',
    app_rate_24: '0.59%',
    avg_round_24: 24860,
    app_flat_24: 6,
    char_25: 'mydei',
    app_rate_25: '0.53%',
    avg_round_25: 32247,
    app_flat_25: 17,
    char_26: 'acheron',
    app_rate_26: '0.5%',
    avg_round_26: 27975,
    app_flat_26: 16,
    char_27: 'bronya',
    app_rate_27: '0.48%',
    avg_round_27: 26702,
    app_flat_27: 19,
    char_28: 'serval',
    app_rate_28: '0.41%',
    avg_round_28: 31489,
    app_flat_28: 18,
    char_29: 'clara',
    app_rate_29: '0.36%',
    avg_round_29: 29000,
    app_flat_29: 10,
    char_30: 'jiaoqiu',
    app_rate_30: '0.34%',
    avg_round_30: 30851,
    app_flat_30: 7
  },
  {
    char: 'aventurine',
    app: 46.23,
    char_1: 'the-herta',
    app_rate_1: '39.17%',
    avg_round_1: 39042,
    app_flat_1: 1627,
    char_2: 'herta',
    app_rate_2: '35.21%',
    avg_round_2: 37669,
    app_flat_2: 1373,
    char_3: 'tribbie',
    app_rate_3: '31.16%',
    avg_round_3: 39828,
    app_flat_3: 1058,
    char_4: 'robin',
    app_rate_4: '29.45%',
    avg_round_4: 31910,
    app_flat_4: 785,
    char_5: 'acheron',
    app_rate_5: '29.38%',
    avg_round_5: 29763,
    app_flat_5: 677,
    char_6: 'sunday',
    app_rate_6: '19.82%',
    avg_round_6: 30668,
    app_flat_6: 493,
    char_7: 'jiaoqiu',
    app_rate_7: '19.14%',
    avg_round_7: 30785,
    app_flat_7: 448,
    char_8: 'jade',
    app_rate_8: '16.44%',
    avg_round_8: 39288,
    app_flat_8: 554,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '13.68%',
    avg_round_9: 36118,
    app_flat_9: 617,
    char_10: 'pela',
    app_rate_10: '12.06%',
    avg_round_10: 29144,
    app_flat_10: 379,
    char_11: 'jing-yuan',
    app_rate_11: '10.77%',
    avg_round_11: 30362,
    app_flat_11: 287,
    char_12: 'sparkle',
    app_rate_12: '7.43%',
    avg_round_12: 27941,
    app_flat_12: 64,
    char_13: 'ruan-mei',
    app_rate_13: '4.87%',
    avg_round_13: 28412,
    app_flat_13: 130,
    char_14: 'kafka',
    app_rate_14: '3.73%',
    avg_round_14: 25930,
    app_flat_14: 109,
    char_15: 'feixiao',
    app_rate_15: '3.65%',
    avg_round_15: 25756,
    app_flat_15: 56,
    char_16: 'black-swan',
    app_rate_16: '3.22%',
    avg_round_16: 25936,
    app_flat_16: 87,
    char_17: 'serval',
    app_rate_17: '3.02%',
    avg_round_17: 38161,
    app_flat_17: 120,
    char_18: 'himeko',
    app_rate_18: '2.57%',
    avg_round_18: 25421,
    app_flat_18: 80,
    char_19: 'aglaea',
    app_rate_19: '2.11%',
    avg_round_19: 31372,
    app_flat_19: 58,
    char_20: 'tingyun-fugue',
    app_rate_20: '1.91%',
    avg_round_20: 27532,
    app_flat_20: 68,
    char_21: 'argenti',
    app_rate_21: '1.91%',
    avg_round_21: 33962,
    app_flat_21: 58,
    char_22: 'yunli',
    app_rate_22: '1.69%',
    avg_round_22: 31231,
    app_flat_22: 42,
    char_23: 'rappa',
    app_rate_23: '1.2%',
    avg_round_23: 25760,
    app_flat_23: 50,
    char_24: 'bronya',
    app_rate_24: '0.92%',
    avg_round_24: 25953,
    app_flat_24: 6,
    char_25: 'clara',
    app_rate_25: '0.88%',
    avg_round_25: 27001,
    app_flat_25: 27,
    char_26: 'topaz',
    app_rate_26: '0.83%',
    avg_round_26: 24496,
    app_flat_26: 10,
    char_27: 'silver-wolf',
    app_rate_27: '0.8%',
    avg_round_27: 24443,
    app_flat_27: 23,
    char_28: 'tingyun',
    app_rate_28: '0.69%',
    avg_round_28: 26278,
    app_flat_28: 18,
    char_29: 'march-7th-swordmaster',
    app_rate_29: '0.48%',
    avg_round_29: 23880,
    app_flat_29: 16,
    char_30: 'trailblazer-harmony',
    app_rate_30: '0.46%',
    avg_round_30: 23558,
    app_flat_30: 19
  },
  {
    char: 'robin',
    app: 45.97,
    char_1: 'sunday',
    app_rate_1: '36.8%',
    avg_round_1: 30269,
    app_flat_1: 963,
    char_2: 'herta',
    app_rate_2: '34.4%',
    avg_round_2: 33497,
    app_flat_2: 1071,
    char_3: 'aventurine',
    app_rate_3: '29.61%',
    avg_round_3: 31910,
    app_flat_3: 785,
    char_4: 'the-herta',
    app_rate_4: '24.16%',
    avg_round_4: 38071,
    app_flat_4: 794,
    char_5: 'huohuo',
    app_rate_5: '19.2%',
    avg_round_5: 30379,
    app_flat_5: 540,
    char_6: 'jade',
    app_rate_6: '18.89%',
    avg_round_6: 38067,
    app_flat_6: 574,
    char_7: 'aglaea',
    app_rate_7: '17.67%',
    avg_round_7: 31139,
    app_flat_7: 482,
    char_8: 'jing-yuan',
    app_rate_8: '16.15%',
    avg_round_8: 28691,
    app_flat_8: 434,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '15.67%',
    avg_round_9: 33009,
    app_flat_9: 469,
    char_10: 'tribbie',
    app_rate_10: '13.3%',
    avg_round_10: 37205,
    app_flat_10: 310,
    char_11: 'lingsha',
    app_rate_11: '10.13%',
    avg_round_11: 37118,
    app_flat_11: 306,
    char_12: 'fu-xuan',
    app_rate_12: '7.87%',
    avg_round_12: 31763,
    app_flat_12: 181,
    char_13: 'gallagher',
    app_rate_13: '7.72%',
    avg_round_13: 31725,
    app_flat_13: 213,
    char_14: 'yunli',
    app_rate_14: '6.15%',
    avg_round_14: 30376,
    app_flat_14: 155,
    char_15: 'feixiao',
    app_rate_15: '5.64%',
    avg_round_15: 27957,
    app_flat_15: 105,
    char_16: 'acheron',
    app_rate_16: '4.6%',
    avg_round_16: 27954,
    app_flat_16: 62,
    char_17: 'luocha',
    app_rate_17: '4.14%',
    avg_round_17: 29866,
    app_flat_17: 122,
    char_18: 'ruan-mei',
    app_rate_18: '3.49%',
    avg_round_18: 30421,
    app_flat_18: 82,
    char_19: 'argenti',
    app_rate_19: '2.56%',
    avg_round_19: 32617,
    app_flat_19: 62,
    char_20: 'jiaoqiu',
    app_rate_20: '2.54%',
    avg_round_20: 30791,
    app_flat_20: 27,
    char_21: 'himeko',
    app_rate_21: '2.54%',
    avg_round_21: 24013,
    app_flat_21: 76,
    char_22: 'sparkle',
    app_rate_22: '2.54%',
    avg_round_22: 25880,
    app_flat_22: 38,
    char_23: 'clara',
    app_rate_23: '1.75%',
    avg_round_23: 26366,
    app_flat_23: 51,
    char_24: 'serval',
    app_rate_24: '1.49%',
    avg_round_24: 29629,
    app_flat_24: 38,
    char_25: 'bronya',
    app_rate_25: '1.41%',
    avg_round_25: 29318,
    app_flat_25: 25,
    char_26: 'pela',
    app_rate_26: '1.18%',
    avg_round_26: 25263,
    app_flat_26: 24,
    char_27: 'kafka',
    app_rate_27: '1.16%',
    avg_round_27: 25065,
    app_flat_27: 14,
    char_28: 'tingyun',
    app_rate_28: '0.93%',
    avg_round_28: 25514,
    app_flat_28: 28,
    char_29: 'topaz',
    app_rate_29: '0.93%',
    avg_round_29: 24025,
    app_flat_29: 8,
    char_30: 'march-7th-swordmaster',
    app_rate_30: '0.87%',
    avg_round_30: 24014,
    app_flat_30: 28
  },
  {
    char: 'ruan-mei',
    app: 44.66,
    char_1: 'tingyun-fugue',
    app_rate_1: '59.44%',
    avg_round_1: 31334,
    app_flat_1: 1292,
    char_2: 'lingsha',
    app_rate_2: '39.67%',
    avg_round_2: 30654,
    app_flat_2: 757,
    char_3: 'rappa',
    app_rate_3: '32.2%',
    avg_round_3: 31441,
    app_flat_3: 1179,
    char_4: 'firefly',
    app_rate_4: '32.09%',
    avg_round_4: 25555,
    app_flat_4: 259,
    char_5: 'trailblazer-harmony',
    app_rate_5: '22.01%',
    avg_round_5: 30623,
    app_flat_5: 523,
    char_6: 'herta',
    app_rate_6: '20.78%',
    avg_round_6: 32517,
    app_flat_6: 678,
    char_7: 'gallagher',
    app_rate_7: '13.57%',
    avg_round_7: 26969,
    app_flat_7: 404,
    char_8: 'himeko',
    app_rate_8: '11.16%',
    avg_round_8: 29471,
    app_flat_8: 301,
    char_9: 'the-herta',
    app_rate_9: '11.16%',
    avg_round_9: 37670,
    app_flat_9: 379,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '10.7%',
    avg_round_10: 34603,
    app_flat_10: 371,
    char_11: 'aventurine',
    app_rate_11: '5.04%',
    avg_round_11: 28412,
    app_flat_11: 130,
    char_12: 'tribbie',
    app_rate_12: '4.99%',
    avg_round_12: 37803,
    app_flat_12: 116,
    char_13: 'sunday',
    app_rate_13: '4.51%',
    avg_round_13: 28279,
    app_flat_13: 93,
    char_14: 'jade',
    app_rate_14: '3.84%',
    avg_round_14: 34867,
    app_flat_14: 117,
    char_15: 'robin',
    app_rate_15: '3.59%',
    avg_round_15: 30421,
    app_flat_15: 82,
    char_16: 'acheron',
    app_rate_16: '2.95%',
    avg_round_16: 29297,
    app_flat_16: 45,
    char_17: 'huohuo',
    app_rate_17: '2.92%',
    avg_round_17: 25581,
    app_flat_17: 56,
    char_18: 'kafka',
    app_rate_18: '2.41%',
    avg_round_18: 23353,
    app_flat_18: 24,
    char_19: 'luocha',
    app_rate_19: '2.09%',
    avg_round_19: 26935,
    app_flat_19: 53,
    char_20: 'fu-xuan',
    app_rate_20: '2.04%',
    avg_round_20: 27028,
    app_flat_20: 36,
    char_21: 'black-swan',
    app_rate_21: '1.93%',
    avg_round_21: 22698,
    app_flat_21: 13,
    char_22: 'mydei',
    app_rate_22: '1.66%',
    avg_round_22: 27764,
    app_flat_22: 28,
    char_23: 'sparkle',
    app_rate_23: '1.23%',
    avg_round_23: 29176,
    app_flat_23: 18,
    char_24: 'jiaoqiu',
    app_rate_24: '1.15%',
    avg_round_24: 30191,
    app_flat_24: 14,
    char_25: 'argenti',
    app_rate_25: '1.1%',
    avg_round_25: 31159,
    app_flat_25: 41,
    char_26: 'pela',
    app_rate_26: '1.02%',
    avg_round_26: 30973,
    app_flat_26: 18,
    char_27: 'bronya',
    app_rate_27: '0.93%',
    avg_round_27: 29671,
    app_flat_27: 17,
    char_28: 'jing-yuan',
    app_rate_28: '0.78%',
    avg_round_28: 25887,
    app_flat_28: 17,
    char_29: 'aglaea',
    app_rate_29: '0.75%',
    avg_round_29: 29460,
    app_flat_29: 14,
    char_30: 'serval',
    app_rate_30: '0.7%',
    avg_round_30: 31029,
    app_flat_30: 21
  },
  {
    char: 'trailblazer-remembrance',
    app: 41.03,
    char_1: 'the-herta',
    app_rate_1: '59.88%',
    avg_round_1: 38553,
    app_flat_1: 2465,
    char_2: 'herta',
    app_rate_2: '54.11%',
    avg_round_2: 37728,
    app_flat_2: 2206,
    char_3: 'robin',
    app_rate_3: '17.55%',
    avg_round_3: 33009,
    app_flat_3: 469,
    char_4: 'tribbie',
    app_rate_4: '17.33%',
    avg_round_4: 39662,
    app_flat_4: 547,
    char_5: 'aventurine',
    app_rate_5: '15.42%',
    avg_round_5: 36118,
    app_flat_5: 617,
    char_6: 'sunday',
    app_rate_6: '14.39%',
    avg_round_6: 31129,
    app_flat_6: 404,
    char_7: 'huohuo',
    app_rate_7: '12.92%',
    avg_round_7: 33982,
    app_flat_7: 472,
    char_8: 'lingsha',
    app_rate_8: '11.74%',
    avg_round_8: 38135,
    app_flat_8: 466,
    char_9: 'ruan-mei',
    app_rate_9: '11.65%',
    avg_round_9: 34603,
    app_flat_9: 371,
    char_10: 'jade',
    app_rate_10: '11.08%',
    avg_round_10: 39419,
    app_flat_10: 401,
    char_11: 'aglaea',
    app_rate_11: '9.32%',
    avg_round_11: 30537,
    app_flat_11: 242,
    char_12: 'gallagher',
    app_rate_12: '8.47%',
    avg_round_12: 36647,
    app_flat_12: 348,
    char_13: 'fu-xuan',
    app_rate_13: '6.37%',
    avg_round_13: 33647,
    app_flat_13: 190,
    char_14: 'luocha',
    app_rate_14: '5.78%',
    avg_round_14: 32338,
    app_flat_14: 194,
    char_15: 'serval',
    app_rate_15: '5.28%',
    avg_round_15: 34630,
    app_flat_15: 181,
    char_16: 'mydei',
    app_rate_16: '4.67%',
    avg_round_16: 29229,
    app_flat_16: 88,
    char_17: 'acheron',
    app_rate_17: '4.5%',
    avg_round_17: 29456,
    app_flat_17: 85,
    char_18: 'argenti',
    app_rate_18: '3.94%',
    avg_round_18: 34156,
    app_flat_18: 137,
    char_19: 'sparkle',
    app_rate_19: '3.16%',
    avg_round_19: 31531,
    app_flat_19: 75,
    char_20: 'jiaoqiu',
    app_rate_20: '2.86%',
    avg_round_20: 30037,
    app_flat_20: 52,
    char_21: 'yunli',
    app_rate_21: '2.29%',
    avg_round_21: 30356,
    app_flat_21: 62,
    char_22: 'pela',
    app_rate_22: '2.17%',
    avg_round_22: 30761,
    app_flat_22: 61,
    char_23: 'himeko',
    app_rate_23: '2.01%',
    avg_round_23: 31771,
    app_flat_23: 84,
    char_24: 'tingyun-fugue',
    app_rate_24: '1.94%',
    avg_round_24: 33344,
    app_flat_24: 45,
    char_25: 'bronya',
    app_rate_25: '1.88%',
    avg_round_25: 30304,
    app_flat_25: 42,
    char_26: 'jing-yuan',
    app_rate_26: '1.6%',
    avg_round_26: 26341,
    app_flat_26: 43,
    char_27: 'tingyun',
    app_rate_27: '1.49%',
    avg_round_27: 30119,
    app_flat_27: 54,
    char_28: 'feixiao',
    app_rate_28: '1.2%',
    avg_round_28: 30556,
    app_flat_28: 28,
    char_29: 'rappa',
    app_rate_29: '1.2%',
    avg_round_29: 37882,
    app_flat_29: 37,
    char_30: 'imbibitor-lunae',
    app_rate_30: '0.57%',
    avg_round_30: 22060,
    app_flat_30: 2
  },
  {
    char: 'sunday',
    app: 40.6,
    char_1: 'robin',
    app_rate_1: '41.67%',
    avg_round_1: 30269,
    app_flat_1: 963,
    char_2: 'jing-yuan',
    app_rate_2: '30.39%',
    avg_round_2: 29467,
    app_flat_2: 725,
    char_3: 'aglaea',
    app_rate_3: '28.44%',
    avg_round_3: 32165,
    app_flat_3: 706,
    char_4: 'huohuo',
    app_rate_4: '25.99%',
    avg_round_4: 30855,
    app_flat_4: 652,
    char_5: 'tribbie',
    app_rate_5: '24.69%',
    avg_round_5: 35250,
    app_flat_5: 550,
    char_6: 'aventurine',
    app_rate_6: '22.57%',
    avg_round_6: 30668,
    app_flat_6: 493,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '14.55%',
    avg_round_7: 31129,
    app_flat_7: 404,
    char_8: 'the-herta',
    app_rate_8: '12.05%',
    avg_round_8: 36741,
    app_flat_8: 388,
    char_9: 'herta',
    app_rate_9: '11.11%',
    avg_round_9: 33942,
    app_flat_9: 354,
    char_10: 'fu-xuan',
    app_rate_10: '9.18%',
    avg_round_10: 29906,
    app_flat_10: 195,
    char_11: 'gallagher',
    app_rate_11: '9.0%',
    avg_round_11: 31645,
    app_flat_11: 212,
    char_12: 'lingsha',
    app_rate_12: '8.81%',
    avg_round_12: 34451,
    app_flat_12: 221,
    char_13: 'jade',
    app_rate_13: '7.23%',
    avg_round_13: 37241,
    app_flat_13: 204,
    char_14: 'acheron',
    app_rate_14: '7.02%',
    avg_round_14: 25286,
    app_flat_14: 73,
    char_15: 'luocha',
    app_rate_15: '6.86%',
    avg_round_15: 28963,
    app_flat_15: 154,
    char_16: 'jiaoqiu',
    app_rate_16: '5.74%',
    avg_round_16: 25933,
    app_flat_16: 58,
    char_17: 'mydei',
    app_rate_17: '5.7%',
    avg_round_17: 26770,
    app_flat_17: 106,
    char_18: 'ruan-mei',
    app_rate_18: '4.97%',
    avg_round_18: 28279,
    app_flat_18: 93,
    char_19: 'argenti',
    app_rate_19: '4.0%',
    avg_round_19: 32071,
    app_flat_19: 107,
    char_20: 'sparkle',
    app_rate_20: '3.97%',
    avg_round_20: 25361,
    app_flat_20: 86,
    char_21: 'bronya',
    app_rate_21: '2.9%',
    avg_round_21: 30925,
    app_flat_21: 53,
    char_22: 'yunli',
    app_rate_22: '2.26%',
    avg_round_22: 26690,
    app_flat_22: 43,
    char_23: 'pela',
    app_rate_23: '1.74%',
    avg_round_23: 24320,
    app_flat_23: 20,
    char_24: 'tingyun',
    app_rate_24: '1.58%',
    avg_round_24: 26988,
    app_flat_24: 37,
    char_25: 'imbibitor-lunae',
    app_rate_25: '1.42%',
    avg_round_25: 23740,
    app_flat_25: 2,
    char_26: 'serval',
    app_rate_26: '1.3%',
    avg_round_26: 30571,
    app_flat_26: 38,
    char_27: 'tingyun-fugue',
    app_rate_27: '0.95%',
    avg_round_27: 28360,
    app_flat_27: 14,
    char_28: 'rappa',
    app_rate_28: '0.65%',
    avg_round_28: 29223,
    app_flat_28: 19,
    char_29: 'blade',
    app_rate_29: '0.58%',
    avg_round_29: 31889,
    app_flat_29: 9,
    char_30: 'bailu',
    app_rate_30: '0.49%',
    avg_round_30: 26753,
    app_flat_30: 12
  },
  {
    char: 'lingsha',
    app: 39.11,
    char_1: 'ruan-mei',
    app_rate_1: '45.3%',
    avg_round_1: 30654,
    app_flat_1: 757,
    char_2: 'tingyun-fugue',
    app_rate_2: '41.49%',
    avg_round_2: 30995,
    app_flat_2: 656,
    char_3: 'the-herta',
    app_rate_3: '37.23%',
    avg_round_3: 39625,
    app_flat_3: 1256,
    char_4: 'tribbie',
    app_rate_4: '26.12%',
    avg_round_4: 40000,
    app_flat_4: 735,
    char_5: 'firefly',
    app_rate_5: '22.66%',
    avg_round_5: 25801,
    app_flat_5: 160,
    char_6: 'herta',
    app_rate_6: '21.68%',
    avg_round_6: 38927,
    app_flat_6: 769,
    char_7: 'jade',
    app_rate_7: '19.45%',
    avg_round_7: 39930,
    app_flat_7: 574,
    char_8: 'rappa',
    app_rate_8: '17.32%',
    avg_round_8: 31652,
    app_flat_8: 532,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '12.31%',
    avg_round_9: 38135,
    app_flat_9: 466,
    char_10: 'robin',
    app_rate_10: '11.91%',
    avg_round_10: 37118,
    app_flat_10: 306,
    char_11: 'trailblazer-harmony',
    app_rate_11: '9.6%',
    avg_round_11: 26087,
    app_flat_11: 147,
    char_12: 'sunday',
    app_rate_12: '9.14%',
    avg_round_12: 34451,
    app_flat_12: 221,
    char_13: 'acheron',
    app_rate_13: '4.94%',
    avg_round_13: 30472,
    app_flat_13: 96,
    char_14: 'lingsha',
    app_rate_14: '4.7%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'serval',
    app_rate_15: '3.19%',
    avg_round_15: 38679,
    app_flat_15: 101,
    char_16: 'himeko',
    app_rate_16: '2.31%',
    avg_round_16: 29762,
    app_flat_16: 53,
    char_17: 'aglaea',
    app_rate_17: '2.17%',
    avg_round_17: 33076,
    app_flat_17: 66,
    char_18: 'jiaoqiu',
    app_rate_18: '2.09%',
    avg_round_18: 32230,
    app_flat_18: 36,
    char_19: 'sparkle',
    app_rate_19: '1.75%',
    avg_round_19: 31757,
    app_flat_19: 25,
    char_20: 'jing-yuan',
    app_rate_20: '1.55%',
    avg_round_20: 29836,
    app_flat_20: 39,
    char_21: 'pela',
    app_rate_21: '1.49%',
    avg_round_21: 28516,
    app_flat_21: 37,
    char_22: 'kafka',
    app_rate_22: '1.04%',
    avg_round_22: 25880,
    app_flat_22: 18,
    char_23: 'argenti',
    app_rate_23: '1.0%',
    avg_round_23: 39320,
    app_flat_23: 28,
    char_24: 'black-swan',
    app_rate_24: '0.71%',
    avg_round_24: 24978,
    app_flat_24: 13,
    char_25: 'yunli',
    app_rate_25: '0.66%',
    avg_round_25: 32556,
    app_flat_25: 20,
    char_26: 'bronya',
    app_rate_26: '0.58%',
    avg_round_26: 33777,
    app_flat_26: 7,
    char_27: 'feixiao',
    app_rate_27: '0.55%',
    avg_round_27: 33905,
    app_flat_27: 8,
    char_28: 'tingyun',
    app_rate_28: '0.27%',
    avg_round_28: 31686,
    app_flat_28: 7,
    char_29: 'clara',
    app_rate_29: '0.22%',
    avg_round_29: 27360,
    app_flat_29: 5,
    char_30: 'mydei',
    app_rate_30: '0.18%',
    avg_round_30: 27176,
    app_flat_30: 5
  },
  {
    char: 'acheron',
    app: 32.69,
    char_1: 'jiaoqiu',
    app_rate_1: '56.42%',
    avg_round_1: 30410,
    app_flat_1: 922,
    char_2: 'aventurine',
    app_rate_2: '41.56%',
    avg_round_2: 29763,
    app_flat_2: 677,
    char_3: 'pela',
    app_rate_3: '38.29%',
    avg_round_3: 28706,
    app_flat_3: 825,
    char_4: 'tribbie',
    app_rate_4: '25.08%',
    avg_round_4: 35805,
    app_flat_4: 340,
    char_5: 'fu-xuan',
    app_rate_5: '23.45%',
    avg_round_5: 26748,
    app_flat_5: 317,
    char_6: 'sparkle',
    app_rate_6: '18.37%',
    avg_round_6: 26695,
    app_flat_6: 63,
    char_7: 'kafka',
    app_rate_7: '16.13%',
    avg_round_7: 25191,
    app_flat_7: 303,
    char_8: 'gallagher',
    app_rate_8: '13.88%',
    avg_round_8: 28913,
    app_flat_8: 274,
    char_9: 'black-swan',
    app_rate_9: '12.22%',
    avg_round_9: 24477,
    app_flat_9: 220,
    char_10: 'sunday',
    app_rate_10: '8.72%',
    avg_round_10: 25286,
    app_flat_10: 73,
    char_11: 'robin',
    app_rate_11: '6.47%',
    avg_round_11: 27954,
    app_flat_11: 62,
    char_12: 'lingsha',
    app_rate_12: '5.91%',
    avg_round_12: 30472,
    app_flat_12: 96,
    char_13: 'tingyun-fugue',
    app_rate_13: '5.75%',
    avg_round_13: 29465,
    app_flat_13: 117,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '5.64%',
    avg_round_14: 29456,
    app_flat_14: 85,
    char_15: 'ruan-mei',
    app_rate_15: '4.03%',
    avg_round_15: 29297,
    app_flat_15: 45,
    char_16: 'silver-wolf',
    app_rate_16: '3.49%',
    avg_round_16: 23981,
    app_flat_16: 64,
    char_17: 'bronya',
    app_rate_17: '2.72%',
    avg_round_17: 25560,
    app_flat_17: 2,
    char_18: 'huohuo',
    app_rate_18: '2.57%',
    avg_round_18: 26033,
    app_flat_18: 34,
    char_19: 'gepard',
    app_rate_19: '1.92%',
    avg_round_19: 24584,
    app_flat_19: 27,
    char_20: 'luocha',
    app_rate_20: '1.72%',
    avg_round_20: 25790,
    app_flat_20: 24,
    char_21: 'jade',
    app_rate_21: '1.09%',
    avg_round_21: 31418,
    app_flat_21: 18,
    char_22: 'herta',
    app_rate_22: '0.94%',
    avg_round_22: 27975,
    app_flat_22: 16,
    char_23: 'himeko',
    app_rate_23: '0.7%',
    avg_round_23: 30091,
    app_flat_23: 11,
    char_24: 'guinaifen',
    app_rate_24: '0.37%',
    avg_round_24: 23977,
    app_flat_24: 14,
    char_25: 'serval',
    app_rate_25: '0.35%',
    avg_round_25: 26910,
    app_flat_25: 4,
    char_26: 'march-7th',
    app_rate_26: '0.31%',
    avg_round_26: 27330,
    app_flat_26: 4,
    char_27: 'yunli',
    app_rate_27: '0.26%',
    avg_round_27: 26053,
    app_flat_27: 3,
    char_28: 'bailu',
    app_rate_28: '0.22%',
    avg_round_28: 21480,
    app_flat_28: 1,
    char_29: 'the-herta',
    app_rate_29: '0.17%',
    avg_round_29: 30440,
    app_flat_29: 1,
    char_30: 'firefly',
    app_rate_30: '0.15%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'tingyun-fugue',
    app: 30.77,
    char_1: 'ruan-mei',
    app_rate_1: '86.29%',
    avg_round_1: 31334,
    app_flat_1: 1292,
    char_2: 'lingsha',
    app_rate_2: '52.74%',
    avg_round_2: 30995,
    app_flat_2: 656,
    char_3: 'firefly',
    app_rate_3: '42.23%',
    avg_round_3: 25811,
    app_flat_3: 252,
    char_4: 'rappa',
    app_rate_4: '39.22%',
    avg_round_4: 32792,
    app_flat_4: 956,
    char_5: 'trailblazer-harmony',
    app_rate_5: '19.56%',
    avg_round_5: 37281,
    app_flat_5: 286,
    char_6: 'himeko',
    app_rate_6: '14.59%',
    avg_round_6: 30108,
    app_flat_6: 242,
    char_7: 'gallagher',
    app_rate_7: '14.29%',
    avg_round_7: 27558,
    app_flat_7: 293,
    char_8: 'herta',
    app_rate_8: '6.51%',
    avg_round_8: 29085,
    app_flat_8: 133,
    char_9: 'acheron',
    app_rate_9: '6.11%',
    avg_round_9: 29465,
    app_flat_9: 117,
    char_10: 'tribbie',
    app_rate_10: '2.99%',
    avg_round_10: 34232,
    app_flat_10: 35,
    char_11: 'aventurine',
    app_rate_11: '2.87%',
    avg_round_11: 27532,
    app_flat_11: 68,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '2.59%',
    avg_round_12: 33344,
    app_flat_12: 45,
    char_13: 'jiaoqiu',
    app_rate_13: '1.74%',
    avg_round_13: 30702,
    app_flat_13: 36,
    char_14: 'huohuo',
    app_rate_14: '1.3%',
    avg_round_14: 26434,
    app_flat_14: 26,
    char_15: 'sunday',
    app_rate_15: '1.25%',
    avg_round_15: 28360,
    app_flat_15: 14,
    char_16: 'pela',
    app_rate_16: '1.2%',
    avg_round_16: 26851,
    app_flat_16: 27,
    char_17: 'fu-xuan',
    app_rate_17: '1.11%',
    avg_round_17: 27061,
    app_flat_17: 17,
    char_18: 'luocha',
    app_rate_18: '0.72%',
    avg_round_18: 27289,
    app_flat_18: 17,
    char_19: 'the-herta',
    app_rate_19: '0.67%',
    avg_round_19: 32083,
    app_flat_19: 15,
    char_20: 'jade',
    app_rate_20: '0.6%',
    avg_round_20: 34709,
    app_flat_20: 11,
    char_21: 'kafka',
    app_rate_21: '0.56%',
    avg_round_21: 24713,
    app_flat_21: 12,
    char_22: 'bronya',
    app_rate_22: '0.56%',
    avg_round_22: 32750,
    app_flat_22: 8,
    char_23: 'robin',
    app_rate_23: '0.56%',
    avg_round_23: 27575,
    app_flat_23: 8,
    char_24: 'xueyi',
    app_rate_24: '0.3%',
    avg_round_24: 25440,
    app_flat_24: 4,
    char_25: 'argenti',
    app_rate_25: '0.28%',
    avg_round_25: 29620,
    app_flat_25: 6,
    char_26: 'boothill',
    app_rate_26: '0.21%',
    avg_round_26: 26800,
    app_flat_26: 2,
    char_27: 'gepard',
    app_rate_27: '0.19%',
    avg_round_27: 23920,
    app_flat_27: 4,
    char_28: 'sparkle',
    app_rate_28: '0.19%',
    avg_round_28: 28980,
    app_flat_28: 2,
    char_29: 'serval',
    app_rate_29: '0.16%',
    avg_round_29: 26016,
    app_flat_29: 5,
    char_30: 'black-swan',
    app_rate_30: '0.12%',
    avg_round_30: 23560,
    app_flat_30: 3
  },
  {
    char: 'jade',
    app: 29.01,
    char_1: 'the-herta',
    app_rate_1: '62.19%',
    avg_round_1: 39947,
    app_flat_1: 1383,
    char_2: 'tribbie',
    app_rate_2: '47.58%',
    avg_round_2: 40000,
    app_flat_2: 971,
    char_3: 'robin',
    app_rate_3: '29.93%',
    avg_round_3: 38067,
    app_flat_3: 574,
    char_4: 'lingsha',
    app_rate_4: '26.22%',
    avg_round_4: 39930,
    app_flat_4: 574,
    char_5: 'aventurine',
    app_rate_5: '26.2%',
    avg_round_5: 39288,
    app_flat_5: 554,
    char_6: 'herta',
    app_rate_6: '16.82%',
    avg_round_6: 36502,
    app_flat_6: 365,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '15.66%',
    avg_round_7: 39419,
    app_flat_7: 401,
    char_8: 'huohuo',
    app_rate_8: '15.49%',
    avg_round_8: 39596,
    app_flat_8: 331,
    char_9: 'fu-xuan',
    app_rate_9: '12.64%',
    avg_round_9: 38752,
    app_flat_9: 236,
    char_10: 'sunday',
    app_rate_10: '10.12%',
    avg_round_10: 37241,
    app_flat_10: 204,
    char_11: 'ruan-mei',
    app_rate_11: '5.92%',
    avg_round_11: 34867,
    app_flat_11: 117,
    char_12: 'luocha',
    app_rate_12: '5.08%',
    avg_round_12: 37077,
    app_flat_12: 114,
    char_13: 'gallagher',
    app_rate_13: '4.39%',
    avg_round_13: 38727,
    app_flat_13: 119,
    char_14: 'sparkle',
    app_rate_14: '2.55%',
    avg_round_14: 33786,
    app_flat_14: 32,
    char_15: 'jing-yuan',
    app_rate_15: '2.55%',
    avg_round_15: 29387,
    app_flat_15: 51,
    char_16: 'feixiao',
    app_rate_16: '1.72%',
    avg_round_16: 32573,
    app_flat_16: 6,
    char_17: 'argenti',
    app_rate_17: '1.55%',
    avg_round_17: 37870,
    app_flat_17: 30,
    char_18: 'aglaea',
    app_rate_18: '1.55%',
    avg_round_18: 31865,
    app_flat_18: 19,
    char_19: 'yunli',
    app_rate_19: '1.47%',
    avg_round_19: 38288,
    app_flat_19: 30,
    char_20: 'blade',
    app_rate_20: '1.47%',
    avg_round_20: 33793,
    app_flat_20: 22,
    char_21: 'acheron',
    app_rate_21: '1.23%',
    avg_round_21: 31418,
    app_flat_21: 18,
    char_22: 'serval',
    app_rate_22: '0.96%',
    avg_round_22: 31315,
    app_flat_22: 22,
    char_23: 'himeko',
    app_rate_23: '0.76%',
    avg_round_23: 32654,
    app_flat_23: 20,
    char_24: 'tingyun-fugue',
    app_rate_24: '0.64%',
    avg_round_24: 34709,
    app_flat_24: 11,
    char_25: 'clara',
    app_rate_25: '0.56%',
    avg_round_25: 31391,
    app_flat_25: 13,
    char_26: 'tingyun',
    app_rate_26: '0.54%',
    avg_round_26: 34144,
    app_flat_26: 10,
    char_27: 'jiaoqiu',
    app_rate_27: '0.54%',
    avg_round_27: 32504,
    app_flat_27: 5,
    char_28: 'lynx',
    app_rate_28: '0.52%',
    avg_round_28: 34240,
    app_flat_28: 10,
    char_29: 'bronya',
    app_rate_29: '0.52%',
    avg_round_29: 34580,
    app_flat_29: 8,
    char_30: 'kafka',
    app_rate_30: '0.49%',
    avg_round_30: 30309,
    app_flat_30: 7
  },
  {
    char: 'huohuo',
    app: 26.73,
    char_1: 'tribbie',
    app_rate_1: '41.51%',
    avg_round_1: 39161,
    app_flat_1: 777,
    char_2: 'sunday',
    app_rate_2: '39.46%',
    avg_round_2: 30855,
    app_flat_2: 652,
    char_3: 'the-herta',
    app_rate_3: '39.3%',
    avg_round_3: 39503,
    app_flat_3: 873,
    char_4: 'robin',
    app_rate_4: '33.01%',
    avg_round_4: 30379,
    app_flat_4: 540,
    char_5: 'aglaea',
    app_rate_5: '25.74%',
    avg_round_5: 31162,
    app_flat_5: 446,
    char_6: 'herta',
    app_rate_6: '25.26%',
    avg_round_6: 38870,
    app_flat_6: 579,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '19.82%',
    avg_round_7: 33982,
    app_flat_7: 472,
    char_8: 'jade',
    app_rate_8: '16.81%',
    avg_round_8: 39596,
    app_flat_8: 331,
    char_9: 'jing-yuan',
    app_rate_9: '9.97%',
    avg_round_9: 28138,
    app_flat_9: 160,
    char_10: 'yunli',
    app_rate_10: '6.34%',
    avg_round_10: 31132,
    app_flat_10: 90,
    char_11: 'serval',
    app_rate_11: '5.54%',
    avg_round_11: 37540,
    app_flat_11: 108,
    char_12: 'ruan-mei',
    app_rate_12: '4.88%',
    avg_round_12: 25581,
    app_flat_12: 56,
    char_13: 'argenti',
    app_rate_13: '4.69%',
    avg_round_13: 34524,
    app_flat_13: 88,
    char_14: 'sparkle',
    app_rate_14: '4.02%',
    avg_round_14: 26383,
    app_flat_14: 39,
    char_15: 'kafka',
    app_rate_15: '3.92%',
    avg_round_15: 24040,
    app_flat_15: 29,
    char_16: 'black-swan',
    app_rate_16: '3.3%',
    avg_round_16: 23324,
    app_flat_16: 21,
    char_17: 'acheron',
    app_rate_17: '3.14%',
    avg_round_17: 26033,
    app_flat_17: 34,
    char_18: 'tingyun',
    app_rate_18: '2.0%',
    avg_round_18: 28155,
    app_flat_18: 31,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.49%',
    avg_round_19: 26434,
    app_flat_19: 26,
    char_20: 'rappa',
    app_rate_20: '1.28%',
    avg_round_20: 25858,
    app_flat_20: 25,
    char_21: 'jiaoqiu',
    app_rate_21: '1.25%',
    avg_round_21: 28407,
    app_flat_21: 12,
    char_22: 'himeko',
    app_rate_22: '1.15%',
    avg_round_22: 29322,
    app_flat_22: 22,
    char_23: 'imbibitor-lunae',
    app_rate_23: '0.91%',
    avg_round_23: 22960,
    app_flat_23: 1,
    char_24: 'bronya',
    app_rate_24: '0.88%',
    avg_round_24: 26953,
    app_flat_24: 10,
    char_25: 'mydei',
    app_rate_25: '0.85%',
    avg_round_25: 24360,
    app_flat_25: 11,
    char_26: 'clara',
    app_rate_26: '0.69%',
    avg_round_26: 25480,
    app_flat_26: 10,
    char_27: 'pela',
    app_rate_27: '0.45%',
    avg_round_27: 26973,
    app_flat_27: 9,
    char_28: 'blade',
    app_rate_28: '0.37%',
    avg_round_28: 33920,
    app_flat_28: 1,
    char_29: 'trailblazer-harmony',
    app_rate_29: '0.35%',
    avg_round_29: 24585,
    app_flat_29: 8,
    char_30: 'feixiao',
    app_rate_30: '0.32%',
    avg_round_30: 26760,
    app_flat_30: 3
  },
  {
    char: 'gallagher',
    app: 21.94,
    char_1: 'the-herta',
    app_rate_1: '29.58%',
    avg_round_1: 39006,
    app_flat_1: 672,
    char_2: 'ruan-mei',
    app_rate_2: '27.63%',
    avg_round_2: 26969,
    app_flat_2: 404,
    char_3: 'herta',
    app_rate_3: '24.35%',
    avg_round_3: 38490,
    app_flat_3: 537,
    char_4: 'tribbie',
    app_rate_4: '23.64%',
    avg_round_4: 39615,
    app_flat_4: 425,
    char_5: 'acheron',
    app_rate_5: '20.68%',
    avg_round_5: 28913,
    app_flat_5: 274,
    char_6: 'tingyun-fugue',
    app_rate_6: '20.03%',
    avg_round_6: 27558,
    app_flat_6: 293,
    char_7: 'sunday',
    app_rate_7: '16.66%',
    avg_round_7: 31645,
    app_flat_7: 212,
    char_8: 'rappa',
    app_rate_8: '16.23%',
    avg_round_8: 27305,
    app_flat_8: 339,
    char_9: 'robin',
    app_rate_9: '16.17%',
    avg_round_9: 31725,
    app_flat_9: 213,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '15.84%',
    avg_round_10: 36647,
    app_flat_10: 348,
    char_11: 'jiaoqiu',
    app_rate_11: '13.86%',
    avg_round_11: 29334,
    app_flat_11: 193,
    char_12: 'firefly',
    app_rate_12: '10.55%',
    avg_round_12: 24322,
    app_flat_12: 52,
    char_13: 'trailblazer-harmony',
    app_rate_13: '9.87%',
    avg_round_13: 24785,
    app_flat_13: 155,
    char_14: 'pela',
    app_rate_14: '8.77%',
    avg_round_14: 28567,
    app_flat_14: 167,
    char_15: 'jing-yuan',
    app_rate_15: '6.46%',
    avg_round_15: 30696,
    app_flat_15: 87,
    char_16: 'jade',
    app_rate_16: '5.81%',
    avg_round_16: 38727,
    app_flat_16: 119,
    char_17: 'serval',
    app_rate_17: '5.36%',
    avg_round_17: 36891,
    app_flat_17: 103,
    char_18: 'aglaea',
    app_rate_18: '4.64%',
    avg_round_18: 32472,
    app_flat_18: 63,
    char_19: 'kafka',
    app_rate_19: '3.83%',
    avg_round_19: 25472,
    app_flat_19: 49,
    char_20: 'sparkle',
    app_rate_20: '3.73%',
    avg_round_20: 27126,
    app_flat_20: 21,
    char_21: 'himeko',
    app_rate_21: '3.05%',
    avg_round_21: 27474,
    app_flat_21: 55,
    char_22: 'black-swan',
    app_rate_22: '2.95%',
    avg_round_22: 24343,
    app_flat_22: 35,
    char_23: 'argenti',
    app_rate_23: '2.14%',
    avg_round_23: 39513,
    app_flat_23: 45,
    char_24: 'mydei',
    app_rate_24: '1.98%',
    avg_round_24: 25263,
    app_flat_24: 11,
    char_25: 'bronya',
    app_rate_25: '1.4%',
    avg_round_25: 25320,
    app_flat_25: 8,
    char_26: 'tingyun',
    app_rate_26: '0.88%',
    avg_round_26: 25542,
    app_flat_26: 17,
    char_27: 'feixiao',
    app_rate_27: '0.71%',
    avg_round_27: 25420,
    app_flat_27: 10,
    char_28: 'yunli',
    app_rate_28: '0.68%',
    avg_round_28: 31606,
    app_flat_28: 7,
    char_29: 'silver-wolf',
    app_rate_29: '0.52%',
    avg_round_29: 23422,
    app_flat_29: 9,
    char_30: 'imbibitor-lunae',
    app_rate_30: '0.36%',
    avg_round_30: 24000,
    app_flat_30: 1
  },
  {
    char: 'fu-xuan',
    app: 20.76,
    char_1: 'tribbie',
    app_rate_1: '41.8%',
    avg_round_1: 38766,
    app_flat_1: 473,
    char_2: 'acheron',
    app_rate_2: '36.93%',
    avg_round_2: 26748,
    app_flat_2: 317,
    char_3: 'the-herta',
    app_rate_3: '28.89%',
    avg_round_3: 39077,
    app_flat_3: 424,
    char_4: 'herta',
    app_rate_4: '21.83%',
    avg_round_4: 37890,
    app_flat_4: 302,
    char_5: 'sunday',
    app_rate_5: '17.95%',
    avg_round_5: 29906,
    app_flat_5: 195,
    char_6: 'jade',
    app_rate_6: '17.67%',
    avg_round_6: 38752,
    app_flat_6: 236,
    char_7: 'jiaoqiu',
    app_rate_7: '17.6%',
    avg_round_7: 27862,
    app_flat_7: 154,
    char_8: 'robin',
    app_rate_8: '17.43%',
    avg_round_8: 31763,
    app_flat_8: 181,
    char_9: 'pela',
    app_rate_9: '14.76%',
    avg_round_9: 26770,
    app_flat_9: 168,
    char_10: 'sparkle',
    app_rate_10: '14.69%',
    avg_round_10: 25799,
    app_flat_10: 63,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '12.59%',
    avg_round_11: 33647,
    app_flat_11: 190,
    char_12: 'kafka',
    app_rate_12: '8.03%',
    avg_round_12: 24633,
    app_flat_12: 95,
    char_13: 'aglaea',
    app_rate_13: '7.79%',
    avg_round_13: 31720,
    app_flat_13: 84,
    char_14: 'jing-yuan',
    app_rate_14: '7.65%',
    avg_round_14: 27818,
    app_flat_14: 80,
    char_15: 'black-swan',
    app_rate_15: '5.22%',
    avg_round_15: 24210,
    app_flat_15: 56,
    char_16: 'serval',
    app_rate_16: '4.5%',
    avg_round_16: 34427,
    app_flat_16: 64,
    char_17: 'ruan-mei',
    app_rate_17: '4.39%',
    avg_round_17: 27028,
    app_flat_17: 36,
    char_18: 'yunli',
    app_rate_18: '2.4%',
    avg_round_18: 32067,
    app_flat_18: 30,
    char_19: 'silver-wolf',
    app_rate_19: '2.23%',
    avg_round_19: 23640,
    app_flat_19: 22,
    char_20: 'argenti',
    app_rate_20: '1.96%',
    avg_round_20: 34584,
    app_flat_20: 32,
    char_21: 'himeko',
    app_rate_21: '1.89%',
    avg_round_21: 29500,
    app_flat_21: 24,
    char_22: 'tingyun-fugue',
    app_rate_22: '1.65%',
    avg_round_22: 27061,
    app_flat_22: 17,
    char_23: 'tingyun',
    app_rate_23: '1.41%',
    avg_round_23: 24855,
    app_flat_23: 16,
    char_24: 'qingque',
    app_rate_24: '1.34%',
    avg_round_24: 24080,
    app_flat_24: 7,
    char_25: 'bronya',
    app_rate_25: '1.34%',
    avg_round_25: 25260,
    app_flat_25: 4,
    char_26: 'clara',
    app_rate_26: '1.1%',
    avg_round_26: 27916,
    app_flat_26: 11,
    char_27: 'blade',
    app_rate_27: '0.93%',
    avg_round_27: 36728,
    app_flat_27: 7,
    char_28: 'feixiao',
    app_rate_28: '0.79%',
    avg_round_28: 29160,
    app_flat_28: 10,
    char_29: 'seele',
    app_rate_29: '0.79%',
    avg_round_29: 29880,
    app_flat_29: 3,
    char_30: 'rappa',
    app_rate_30: '0.51%',
    avg_round_30: 24880,
    app_flat_30: 7
  },
  {
    char: 'jiaoqiu',
    app: 19.27,
    char_1: 'acheron',
    app_rate_1: '95.71%',
    avg_round_1: 30410,
    app_flat_1: 922,
    char_2: 'aventurine',
    app_rate_2: '45.91%',
    avg_round_2: 30785,
    app_flat_2: 448,
    char_3: 'pela',
    app_rate_3: '26.06%',
    avg_round_3: 29308,
    app_flat_3: 494,
    char_4: 'tribbie',
    app_rate_4: '20.74%',
    avg_round_4: 39190,
    app_flat_4: 168,
    char_5: 'sparkle',
    app_rate_5: '20.63%',
    avg_round_5: 28222,
    app_flat_5: 37,
    char_6: 'fu-xuan',
    app_rate_6: '18.96%',
    avg_round_6: 27862,
    app_flat_6: 154,
    char_7: 'gallagher',
    app_rate_7: '15.79%',
    avg_round_7: 29334,
    app_flat_7: 193,
    char_8: 'sunday',
    app_rate_8: '12.09%',
    avg_round_8: 25933,
    app_flat_8: 58,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '6.1%',
    avg_round_9: 30037,
    app_flat_9: 52,
    char_10: 'robin',
    app_rate_10: '6.06%',
    avg_round_10: 30791,
    app_flat_10: 27,
    char_11: 'lingsha',
    app_rate_11: '4.25%',
    avg_round_11: 32230,
    app_flat_11: 36,
    char_12: 'kafka',
    app_rate_12: '3.7%',
    avg_round_12: 28409,
    app_flat_12: 46,
    char_13: 'black-swan',
    app_rate_13: '2.96%',
    avg_round_13: 26486,
    app_flat_13: 40,
    char_14: 'tingyun-fugue',
    app_rate_14: '2.77%',
    avg_round_14: 30702,
    app_flat_14: 36,
    char_15: 'ruan-mei',
    app_rate_15: '2.66%',
    avg_round_15: 30191,
    app_flat_15: 14,
    char_16: 'bronya',
    app_rate_16: '2.62%',
    avg_round_16: 26490,
    app_flat_16: 4,
    char_17: 'luocha',
    app_rate_17: '2.59%',
    avg_round_17: 26120,
    app_flat_17: 16,
    char_18: 'huohuo',
    app_rate_18: '1.74%',
    avg_round_18: 28407,
    app_flat_18: 12,
    char_19: 'mydei',
    app_rate_19: '1.44%',
    avg_round_19: 27900,
    app_flat_19: 6,
    char_20: 'silver-wolf',
    app_rate_20: '1.18%',
    avg_round_20: 26929,
    app_flat_20: 14,
    char_21: 'herta',
    app_rate_21: '1.07%',
    avg_round_21: 30851,
    app_flat_21: 7,
    char_22: 'gepard',
    app_rate_22: '0.85%',
    avg_round_22: 26720,
    app_flat_22: 8,
    char_23: 'jade',
    app_rate_23: '0.81%',
    avg_round_23: 32504,
    app_flat_23: 5,
    char_24: 'the-herta',
    app_rate_24: '0.67%',
    avg_round_24: 33930,
    app_flat_24: 4,
    char_25: 'jing-yuan',
    app_rate_25: '0.55%',
    avg_round_25: 27480,
    app_flat_25: 1,
    char_26: 'argenti',
    app_rate_26: '0.55%',
    avg_round_26: 27960,
    app_flat_26: 2,
    char_27: 'tingyun',
    app_rate_27: '0.18%',
    avg_round_27: 33780,
    app_flat_27: 2,
    char_28: 'imbibitor-lunae',
    app_rate_28: '0.15%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'bailu',
    app_rate_29: '0.15%',
    avg_round_29: 21480,
    app_flat_29: 1,
    char_30: 'topaz',
    app_rate_30: '0.11%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'rappa',
    app: 15.89,
    char_1: 'ruan-mei',
    app_rate_1: '90.54%',
    avg_round_1: 31441,
    app_flat_1: 1179,
    char_2: 'tingyun-fugue',
    app_rate_2: '75.96%',
    avg_round_2: 32792,
    app_flat_2: 956,
    char_3: 'lingsha',
    app_rate_3: '42.65%',
    avg_round_3: 31652,
    app_flat_3: 532,
    char_4: 'trailblazer-harmony',
    app_rate_4: '39.91%',
    avg_round_4: 30549,
    app_flat_4: 561,
    char_5: 'gallagher',
    app_rate_5: '22.42%',
    avg_round_5: 27305,
    app_flat_5: 339,
    char_6: 'herta',
    app_rate_6: '3.68%',
    avg_round_6: 30477,
    app_flat_6: 51,
    char_7: 'aventurine',
    app_rate_7: '3.5%',
    avg_round_7: 25760,
    app_flat_7: 50,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '3.09%',
    avg_round_8: 37882,
    app_flat_8: 37,
    char_9: 'firefly',
    app_rate_9: '2.78%',
    avg_round_9: 30687,
    app_flat_9: 11,
    char_10: 'himeko',
    app_rate_10: '2.51%',
    avg_round_10: 34422,
    app_flat_10: 41,
    char_11: 'huohuo',
    app_rate_11: '2.15%',
    avg_round_11: 25858,
    app_flat_11: 25,
    char_12: 'tribbie',
    app_rate_12: '1.97%',
    avg_round_12: 36964,
    app_flat_12: 18,
    char_13: 'luocha',
    app_rate_13: '1.84%',
    avg_round_13: 26692,
    app_flat_13: 24,
    char_14: 'sunday',
    app_rate_14: '1.66%',
    avg_round_14: 29223,
    app_flat_14: 19,
    char_15: 'the-herta',
    app_rate_15: '1.57%',
    avg_round_15: 35400,
    app_flat_15: 14,
    char_16: 'pela',
    app_rate_16: '0.67%',
    avg_round_16: 32500,
    app_flat_16: 10,
    char_17: 'fu-xuan',
    app_rate_17: '0.67%',
    avg_round_17: 24880,
    app_flat_17: 7,
    char_18: 'robin',
    app_rate_18: '0.63%',
    avg_round_18: 30853,
    app_flat_18: 6,
    char_19: 'bronya',
    app_rate_19: '0.58%',
    avg_round_19: 31836,
    app_flat_19: 9,
    char_20: 'sparkle',
    app_rate_20: '0.22%',
    avg_round_20: 29640,
    app_flat_20: 1,
    char_21: 'tingyun',
    app_rate_21: '0.18%',
    avg_round_21: 29820,
    app_flat_21: 2,
    char_22: 'jade',
    app_rate_22: '0.09%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'bailu',
    app_rate_23: '0.09%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'march-7th-swordmaster',
    app_rate_24: '0.09%',
    avg_round_24: 24960,
    app_flat_24: 1,
    char_25: 'mydei',
    app_rate_25: '0.04%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'jingliu',
    app_rate_26: '0.04%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'kafka',
    app_rate_27: '0.04%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'march-7th',
    app_rate_28: '0.04%',
    avg_round_28: 26720,
    app_flat_28: 1,
    char_29: 'aglaea',
    app_rate_29: '0.04%',
    avg_round_29: 20480,
    app_flat_29: 1,
    char_30: 'jiaoqiu',
    app_rate_30: '0.04%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'firefly',
    app: 15.38,
    char_1: 'ruan-mei',
    app_rate_1: '93.19%',
    avg_round_1: 25555,
    app_flat_1: 259,
    char_2: 'tingyun-fugue',
    app_rate_2: '84.48%',
    avg_round_2: 25811,
    app_flat_2: 252,
    char_3: 'lingsha',
    app_rate_3: '57.62%',
    avg_round_3: 25801,
    app_flat_3: 160,
    char_4: 'trailblazer-harmony',
    app_rate_4: '27.56%',
    avg_round_4: 23459,
    app_flat_4: 33,
    char_5: 'gallagher',
    app_rate_5: '15.05%',
    avg_round_5: 24322,
    app_flat_5: 52,
    char_6: 'himeko',
    app_rate_6: '10.88%',
    avg_round_6: 28447,
    app_flat_6: 40,
    char_7: 'rappa',
    app_rate_7: '2.87%',
    avg_round_7: 30687,
    app_flat_7: 11,
    char_8: 'herta',
    app_rate_8: '2.36%',
    avg_round_8: 24860,
    app_flat_8: 6,
    char_9: 'tribbie',
    app_rate_9: '1.2%',
    avg_round_9: 28050,
    app_flat_9: 4,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '1.07%',
    avg_round_10: 24170,
    app_flat_10: 4,
    char_11: 'bronya',
    app_rate_11: '0.65%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'huohuo',
    app_rate_12: '0.51%',
    avg_round_12: 27000,
    app_flat_12: 1,
    char_13: 'aventurine',
    app_rate_13: '0.42%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'acheron',
    app_rate_14: '0.32%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'sunday',
    app_rate_15: '0.28%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'fu-xuan',
    app_rate_16: '0.28%',
    avg_round_16: 27040,
    app_flat_16: 1,
    char_17: 'robin',
    app_rate_17: '0.23%',
    avg_round_17: 24000,
    app_flat_17: 1,
    char_18: 'luocha',
    app_rate_18: '0.19%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'march-7th-swordmaster',
    app_rate_19: '0.14%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'pela',
    app_rate_20: '0.09%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'the-herta',
    app_rate_21: '0.09%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'sparkle',
    app_rate_22: '0.09%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'mydei',
    app_rate_23: '0.05%',
    avg_round_23: 21200,
    app_flat_23: 1,
    char_24: 'kafka',
    app_rate_24: '0.05%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'natasha',
    app_rate_25: '0.05%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'jingliu',
    app_rate_26: '0.05%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'jiaoqiu',
    app_rate_27: '0.05%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'jing-yuan',
    app_rate_28: '0.05%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'guinaifen',
    app_rate_29: '0.05%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'gepard',
    app_rate_30: '0.05%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'aglaea',
    app: 14.02,
    char_1: 'sunday',
    app_rate_1: '82.37%',
    avg_round_1: 32165,
    app_flat_1: 706,
    char_2: 'robin',
    app_rate_2: '57.93%',
    avg_round_2: 31139,
    app_flat_2: 482,
    char_3: 'huohuo',
    app_rate_3: '49.09%',
    avg_round_3: 31162,
    app_flat_3: 446,
    char_4: 'tribbie',
    app_rate_4: '28.4%',
    avg_round_4: 35373,
    app_flat_4: 253,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '27.29%',
    avg_round_5: 30537,
    app_flat_5: 242,
    char_6: 'fu-xuan',
    app_rate_6: '11.53%',
    avg_round_6: 31720,
    app_flat_6: 84,
    char_7: 'gallagher',
    app_rate_7: '7.27%',
    avg_round_7: 32472,
    app_flat_7: 63,
    char_8: 'aventurine',
    app_rate_8: '6.96%',
    avg_round_8: 31372,
    app_flat_8: 58,
    char_9: 'bronya',
    app_rate_9: '6.76%',
    avg_round_9: 31268,
    app_flat_9: 39,
    char_10: 'lingsha',
    app_rate_10: '6.05%',
    avg_round_10: 33076,
    app_flat_10: 66,
    char_11: 'luocha',
    app_rate_11: '4.93%',
    avg_round_11: 31047,
    app_flat_11: 33,
    char_12: 'jade',
    app_rate_12: '3.2%',
    avg_round_12: 31865,
    app_flat_12: 19,
    char_13: 'ruan-mei',
    app_rate_13: '2.39%',
    avg_round_13: 29460,
    app_flat_13: 14,
    char_14: 'sparkle',
    app_rate_14: '1.47%',
    avg_round_14: 29067,
    app_flat_14: 9,
    char_15: 'bailu',
    app_rate_15: '0.81%',
    avg_round_15: 31270,
    app_flat_15: 4,
    char_16: 'tingyun',
    app_rate_16: '0.66%',
    avg_round_16: 23048,
    app_flat_16: 5,
    char_17: 'herta',
    app_rate_17: '0.51%',
    avg_round_17: 30256,
    app_flat_17: 5,
    char_18: 'acheron',
    app_rate_18: '0.3%',
    avg_round_18: 27620,
    app_flat_18: 2,
    char_19: 'lynx',
    app_rate_19: '0.3%',
    avg_round_19: 26160,
    app_flat_19: 2,
    char_20: 'pela',
    app_rate_20: '0.25%',
    avg_round_20: 25480,
    app_flat_20: 3,
    char_21: 'yunli',
    app_rate_21: '0.2%',
    avg_round_21: 26680,
    app_flat_21: 1,
    char_22: 'asta',
    app_rate_22: '0.15%',
    avg_round_22: 28580,
    app_flat_22: 2,
    char_23: 'gepard',
    app_rate_23: '0.15%',
    avg_round_23: 26867,
    app_flat_23: 3,
    char_24: 'kafka',
    app_rate_24: '0.15%',
    avg_round_24: 25180,
    app_flat_24: 2,
    char_25: 'the-herta',
    app_rate_25: '0.1%',
    avg_round_25: 29560,
    app_flat_25: 1,
    char_26: 'tingyun-fugue',
    app_rate_26: '0.1%',
    avg_round_26: 27240,
    app_flat_26: 1,
    char_27: 'jiaoqiu',
    app_rate_27: '0.1%',
    avg_round_27: 29080,
    app_flat_27: 1,
    char_28: 'clara',
    app_rate_28: '0.05%',
    avg_round_28: 33280,
    app_flat_28: 1,
    char_29: 'rappa',
    app_rate_29: '0.05%',
    avg_round_29: 20480,
    app_flat_29: 1,
    char_30: 'trailblazer-harmony',
    app_rate_30: '0.05%',
    avg_round_30: 20480,
    app_flat_30: 1
  },
  {
    char: 'pela',
    app: 13.34,
    char_1: 'acheron',
    app_rate_1: '93.86%',
    avg_round_1: 28706,
    app_flat_1: 825,
    char_2: 'aventurine',
    app_rate_2: '41.83%',
    avg_round_2: 29144,
    app_flat_2: 379,
    char_3: 'jiaoqiu',
    app_rate_3: '37.66%',
    avg_round_3: 29308,
    app_flat_3: 494,
    char_4: 'fu-xuan',
    app_rate_4: '22.97%',
    avg_round_4: 26770,
    app_flat_4: 168,
    char_5: 'tribbie',
    app_rate_5: '22.76%',
    avg_round_5: 34361,
    app_flat_5: 140,
    char_6: 'gallagher',
    app_rate_6: '14.42%',
    avg_round_6: 28567,
    app_flat_6: 167,
    char_7: 'sparkle',
    app_rate_7: '10.74%',
    avg_round_7: 23880,
    app_flat_7: 20,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '6.68%',
    avg_round_8: 30761,
    app_flat_8: 61,
    char_9: 'sunday',
    app_rate_9: '5.29%',
    avg_round_9: 24320,
    app_flat_9: 20,
    char_10: 'kafka',
    app_rate_10: '4.81%',
    avg_round_10: 25544,
    app_flat_10: 59,
    char_11: 'lingsha',
    app_rate_11: '4.38%',
    avg_round_11: 28516,
    app_flat_11: 37,
    char_12: 'robin',
    app_rate_12: '4.06%',
    avg_round_12: 25263,
    app_flat_12: 24,
    char_13: 'silver-wolf',
    app_rate_13: '3.58%',
    avg_round_13: 23384,
    app_flat_13: 42,
    char_14: 'ruan-mei',
    app_rate_14: '3.42%',
    avg_round_14: 30973,
    app_flat_14: 18,
    char_15: 'herta',
    app_rate_15: '3.21%',
    avg_round_15: 32813,
    app_flat_15: 35,
    char_16: 'tingyun-fugue',
    app_rate_16: '2.78%',
    avg_round_16: 26851,
    app_flat_16: 27,
    char_17: 'black-swan',
    app_rate_17: '2.56%',
    avg_round_17: 23056,
    app_flat_17: 22,
    char_18: 'bronya',
    app_rate_18: '2.46%',
    avg_round_18: 24080,
    app_flat_18: 1,
    char_19: 'gepard',
    app_rate_19: '2.19%',
    avg_round_19: 24369,
    app_flat_19: 13,
    char_20: 'the-herta',
    app_rate_20: '1.87%',
    avg_round_20: 35650,
    app_flat_20: 20,
    char_21: 'luocha',
    app_rate_21: '1.07%',
    avg_round_21: 24384,
    app_flat_21: 7,
    char_22: 'jade',
    app_rate_22: '0.96%',
    avg_round_22: 26970,
    app_flat_22: 6,
    char_23: 'huohuo',
    app_rate_23: '0.91%',
    avg_round_23: 26973,
    app_flat_23: 9,
    char_24: 'rappa',
    app_rate_24: '0.8%',
    avg_round_24: 32500,
    app_flat_24: 10,
    char_25: 'trailblazer-harmony',
    app_rate_25: '0.69%',
    avg_round_25: 32500,
    app_flat_25: 10,
    char_26: 'guinaifen',
    app_rate_26: '0.69%',
    avg_round_26: 23967,
    app_flat_26: 12,
    char_27: 'mydei',
    app_rate_27: '0.48%',
    avg_round_27: 25230,
    app_flat_27: 6,
    char_28: 'serval',
    app_rate_28: '0.48%',
    avg_round_28: 32630,
    app_flat_28: 4,
    char_29: 'march-7th',
    app_rate_29: '0.37%',
    avg_round_29: 30880,
    app_flat_29: 1,
    char_30: 'himeko',
    app_rate_30: '0.32%',
    avg_round_30: 25710,
    app_flat_30: 4
  },
  {
    char: 'jing-yuan',
    app: 12.85,
    char_1: 'sunday',
    app_rate_1: '96.01%',
    avg_round_1: 29467,
    app_flat_1: 725,
    char_2: 'robin',
    app_rate_2: '57.76%',
    avg_round_2: 28691,
    app_flat_2: 434,
    char_3: 'aventurine',
    app_rate_3: '38.75%',
    avg_round_3: 30362,
    app_flat_3: 287,
    char_4: 'tribbie',
    app_rate_4: '25.78%',
    avg_round_4: 33956,
    app_flat_4: 187,
    char_5: 'huohuo',
    app_rate_5: '20.73%',
    avg_round_5: 28138,
    app_flat_5: 160,
    char_6: 'fu-xuan',
    app_rate_6: '12.36%',
    avg_round_6: 27818,
    app_flat_6: 80,
    char_7: 'gallagher',
    app_rate_7: '11.03%',
    avg_round_7: 30696,
    app_flat_7: 87,
    char_8: 'luocha',
    app_rate_8: '6.49%',
    avg_round_8: 29841,
    app_flat_8: 60,
    char_9: 'jade',
    app_rate_9: '5.76%',
    avg_round_9: 29387,
    app_flat_9: 51,
    char_10: 'sparkle',
    app_rate_10: '5.16%',
    avg_round_10: 24783,
    app_flat_10: 43,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '5.1%',
    avg_round_11: 26341,
    app_flat_11: 43,
    char_12: 'lingsha',
    app_rate_12: '4.71%',
    avg_round_12: 29836,
    app_flat_12: 39,
    char_13: 'ruan-mei',
    app_rate_13: '2.72%',
    avg_round_13: 25887,
    app_flat_13: 17,
    char_14: 'tingyun',
    app_rate_14: '2.72%',
    avg_round_14: 26302,
    app_flat_14: 18,
    char_15: 'bronya',
    app_rate_15: '1.0%',
    avg_round_15: 22653,
    app_flat_15: 6,
    char_16: 'jiaoqiu',
    app_rate_16: '0.83%',
    avg_round_16: 27480,
    app_flat_16: 1,
    char_17: 'herta',
    app_rate_17: '0.72%',
    avg_round_17: 23312,
    app_flat_17: 7,
    char_18: 'bailu',
    app_rate_18: '0.61%',
    avg_round_18: 26120,
    app_flat_18: 7,
    char_19: 'the-herta',
    app_rate_19: '0.5%',
    avg_round_19: 35800,
    app_flat_19: 3,
    char_20: 'pela',
    app_rate_20: '0.11%',
    avg_round_20: 24360,
    app_flat_20: 1,
    char_21: 'yunli',
    app_rate_21: '0.11%',
    avg_round_21: 22600,
    app_flat_21: 1,
    char_22: 'acheron',
    app_rate_22: '0.11%',
    avg_round_22: 27640,
    app_flat_22: 1,
    char_23: 'gepard',
    app_rate_23: '0.11%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'hanya',
    app_rate_24: '0.11%',
    avg_round_24: 26180,
    app_flat_24: 2,
    char_25: 'clara',
    app_rate_25: '0.11%',
    avg_round_25: 25280,
    app_flat_25: 2,
    char_26: 'lynx',
    app_rate_26: '0.11%',
    avg_round_26: 24640,
    app_flat_26: 1,
    char_27: 'mydei',
    app_rate_27: '0.06%',
    avg_round_27: 22040,
    app_flat_27: 1,
    char_28: 'natasha',
    app_rate_28: '0.06%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'firefly',
    app_rate_29: '0.06%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'trailblazer-harmony',
    app_rate_30: '0.06%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'sparkle',
    app: 12.66,
    char_1: 'acheron',
    app_rate_1: '47.44%',
    avg_round_1: 26695,
    app_flat_1: 63,
    char_2: 'jiaoqiu',
    app_rate_2: '31.4%',
    avg_round_2: 28222,
    app_flat_2: 37,
    char_3: 'aventurine',
    app_rate_3: '27.12%',
    avg_round_3: 27941,
    app_flat_3: 64,
    char_4: 'fu-xuan',
    app_rate_4: '24.09%',
    avg_round_4: 25799,
    app_flat_4: 63,
    char_5: 'tribbie',
    app_rate_5: '18.29%',
    avg_round_5: 32267,
    app_flat_5: 70,
    char_6: 'herta',
    app_rate_6: '15.7%',
    avg_round_6: 31224,
    app_flat_6: 94,
    char_7: 'sunday',
    app_rate_7: '12.72%',
    avg_round_7: 25361,
    app_flat_7: 86,
    char_8: 'the-herta',
    app_rate_8: '11.54%',
    avg_round_8: 34841,
    app_flat_8: 69,
    char_9: 'pela',
    app_rate_9: '11.31%',
    avg_round_9: 23880,
    app_flat_9: 20,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '10.24%',
    avg_round_10: 31531,
    app_flat_10: 75,
    char_11: 'robin',
    app_rate_11: '9.23%',
    avg_round_11: 25880,
    app_flat_11: 38,
    char_12: 'huohuo',
    app_rate_12: '8.5%',
    avg_round_12: 26383,
    app_flat_12: 39,
    char_13: 'gallagher',
    app_rate_13: '6.47%',
    avg_round_13: 27126,
    app_flat_13: 21,
    char_14: 'jade',
    app_rate_14: '5.85%',
    avg_round_14: 33786,
    app_flat_14: 32,
    char_15: 'lingsha',
    app_rate_15: '5.4%',
    avg_round_15: 31757,
    app_flat_15: 25,
    char_16: 'jing-yuan',
    app_rate_16: '5.23%',
    avg_round_16: 24783,
    app_flat_16: 43,
    char_17: 'argenti',
    app_rate_17: '5.18%',
    avg_round_17: 30458,
    app_flat_17: 48,
    char_18: 'yunli',
    app_rate_18: '4.9%',
    avg_round_18: 29872,
    app_flat_18: 24,
    char_19: 'imbibitor-lunae',
    app_rate_19: '4.73%',
    avg_round_19: 22350,
    app_flat_19: 4,
    char_20: 'ruan-mei',
    app_rate_20: '4.33%',
    avg_round_20: 29176,
    app_flat_20: 18,
    char_21: 'mydei',
    app_rate_21: '4.0%',
    avg_round_21: 24380,
    app_flat_21: 20,
    char_22: 'luocha',
    app_rate_22: '3.88%',
    avg_round_22: 24061,
    app_flat_22: 15,
    char_23: 'tingyun',
    app_rate_23: '3.32%',
    avg_round_23: 27328,
    app_flat_23: 20,
    char_24: 'qingque',
    app_rate_24: '2.93%',
    avg_round_24: 23280,
    app_flat_24: 14,
    char_25: 'kafka',
    app_rate_25: '1.74%',
    avg_round_25: 23560,
    app_flat_25: 2,
    char_26: 'bronya',
    app_rate_26: '1.74%',
    avg_round_26: 24728,
    app_flat_26: 7,
    char_27: 'aglaea',
    app_rate_27: '1.63%',
    avg_round_27: 29067,
    app_flat_27: 9,
    char_28: 'clara',
    app_rate_28: '1.41%',
    avg_round_28: 25200,
    app_flat_28: 9,
    char_29: 'seele',
    app_rate_29: '1.35%',
    avg_round_29: 25360,
    app_flat_29: 1,
    char_30: 'silver-wolf',
    app_rate_30: '1.29%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-harmony',
    app: 11.52,
    char_1: 'ruan-mei',
    app_rate_1: '85.34%',
    avg_round_1: 30623,
    app_flat_1: 523,
    char_2: 'rappa',
    app_rate_2: '55.04%',
    avg_round_2: 30549,
    app_flat_2: 561,
    char_3: 'tingyun-fugue',
    app_rate_3: '52.26%',
    avg_round_3: 37281,
    app_flat_3: 286,
    char_4: 'firefly',
    app_rate_4: '36.8%',
    avg_round_4: 23459,
    app_flat_4: 33,
    char_5: 'lingsha',
    app_rate_5: '32.59%',
    avg_round_5: 26087,
    app_flat_5: 147,
    char_6: 'gallagher',
    app_rate_6: '18.8%',
    avg_round_6: 24785,
    app_flat_6: 155,
    char_7: 'himeko',
    app_rate_7: '7.54%',
    avg_round_7: 33140,
    app_flat_7: 41,
    char_8: 'herta',
    app_rate_8: '5.38%',
    avg_round_8: 29269,
    app_flat_8: 38,
    char_9: 'tribbie',
    app_rate_9: '1.92%',
    avg_round_9: 38147,
    app_flat_9: 10,
    char_10: 'aventurine',
    app_rate_10: '1.86%',
    avg_round_10: 23558,
    app_flat_10: 19,
    char_11: 'sunday',
    app_rate_11: '1.61%',
    avg_round_11: 28612,
    app_flat_11: 13,
    char_12: 'luocha',
    app_rate_12: '1.11%',
    avg_round_12: 24760,
    app_flat_12: 10,
    char_13: 'pela',
    app_rate_13: '0.8%',
    avg_round_13: 32500,
    app_flat_13: 10,
    char_14: 'huohuo',
    app_rate_14: '0.8%',
    avg_round_14: 24585,
    app_flat_14: 8,
    char_15: 'bronya',
    app_rate_15: '0.56%',
    avg_round_15: 29573,
    app_flat_15: 3,
    char_16: 'robin',
    app_rate_16: '0.25%',
    avg_round_16: 27320,
    app_flat_16: 1,
    char_17: 'fu-xuan',
    app_rate_17: '0.19%',
    avg_round_17: 27560,
    app_flat_17: 1,
    char_18: 'march-7th-swordmaster',
    app_rate_18: '0.12%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'acheron',
    app_rate_19: '0.12%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'sparkle',
    app_rate_20: '0.12%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'mydei',
    app_rate_21: '0.06%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'jade',
    app_rate_22: '0.06%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'serval',
    app_rate_23: '0.06%',
    avg_round_23: 23480,
    app_flat_23: 1,
    char_24: 'xueyi',
    app_rate_24: '0.06%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'argenti',
    app_rate_25: '0.06%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'aglaea',
    app_rate_26: '0.06%',
    avg_round_26: 20480,
    app_flat_26: 1,
    char_27: 'the-herta',
    app_rate_27: '0.06%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'imbibitor-lunae',
    app_rate_28: '0.06%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'jing-yuan',
    app_rate_29: '0.06%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'lynx',
    app_rate_30: '0.06%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'luocha',
    app: 8.82,
    char_1: 'the-herta',
    app_rate_1: '42.89%',
    avg_round_1: 35872,
    app_flat_1: 334,
    char_2: 'herta',
    app_rate_2: '34.25%',
    avg_round_2: 34221,
    app_flat_2: 271,
    char_3: 'sunday',
    app_rate_3: '31.58%',
    avg_round_3: 28963,
    app_flat_3: 154,
    char_4: 'tribbie',
    app_rate_4: '31.02%',
    avg_round_4: 38533,
    app_flat_4: 199,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '26.9%',
    avg_round_5: 32338,
    app_flat_5: 194,
    char_6: 'robin',
    app_rate_6: '21.57%',
    avg_round_6: 29866,
    app_flat_6: 122,
    char_7: 'jade',
    app_rate_7: '16.72%',
    avg_round_7: 37077,
    app_flat_7: 114,
    char_8: 'mydei',
    app_rate_8: '12.2%',
    avg_round_8: 24705,
    app_flat_8: 42,
    char_9: 'ruan-mei',
    app_rate_9: '10.58%',
    avg_round_9: 26935,
    app_flat_9: 53,
    char_10: 'jing-yuan',
    app_rate_10: '9.45%',
    avg_round_10: 29841,
    app_flat_10: 60,
    char_11: 'aglaea',
    app_rate_11: '7.84%',
    avg_round_11: 31047,
    app_flat_11: 33,
    char_12: 'acheron',
    app_rate_12: '6.38%',
    avg_round_12: 25790,
    app_flat_12: 24,
    char_13: 'jiaoqiu',
    app_rate_13: '5.65%',
    avg_round_13: 26120,
    app_flat_13: 16,
    char_14: 'sparkle',
    app_rate_14: '5.57%',
    avg_round_14: 24061,
    app_flat_14: 15,
    char_15: 'argenti',
    app_rate_15: '4.52%',
    avg_round_15: 31183,
    app_flat_15: 28,
    char_16: 'serval',
    app_rate_16: '3.63%',
    avg_round_16: 34293,
    app_flat_16: 24,
    char_17: 'rappa',
    app_rate_17: '3.31%',
    avg_round_17: 26692,
    app_flat_17: 24,
    char_18: 'yunli',
    app_rate_18: '2.91%',
    avg_round_18: 29278,
    app_flat_18: 19,
    char_19: 'kafka',
    app_rate_19: '2.67%',
    avg_round_19: 25227,
    app_flat_19: 12,
    char_20: 'bronya',
    app_rate_20: '2.67%',
    avg_round_20: 24600,
    app_flat_20: 9,
    char_21: 'tingyun-fugue',
    app_rate_21: '2.5%',
    avg_round_21: 27289,
    app_flat_21: 17,
    char_22: 'himeko',
    app_rate_22: '2.18%',
    avg_round_22: 24487,
    app_flat_22: 12,
    char_23: 'imbibitor-lunae',
    app_rate_23: '2.1%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'tingyun',
    app_rate_24: '1.86%',
    avg_round_24: 28920,
    app_flat_24: 12,
    char_25: 'black-swan',
    app_rate_25: '1.78%',
    avg_round_25: 24364,
    app_flat_25: 9,
    char_26: 'blade',
    app_rate_26: '1.7%',
    avg_round_26: 26130,
    app_flat_26: 8,
    char_27: 'pela',
    app_rate_27: '1.62%',
    avg_round_27: 24384,
    app_flat_27: 7,
    char_28: 'trailblazer-harmony',
    app_rate_28: '1.45%',
    avg_round_28: 24760,
    app_flat_28: 10,
    char_29: 'clara',
    app_rate_29: '0.89%',
    avg_round_29: 24368,
    app_flat_29: 5,
    char_30: 'jingliu',
    app_rate_30: '0.32%',
    avg_round_30: 22640,
    app_flat_30: 1
  },
  {
    char: 'himeko',
    app: 8.56,
    char_1: 'ruan-mei',
    app_rate_1: '58.28%',
    avg_round_1: 29471,
    app_flat_1: 301,
    char_2: 'tingyun-fugue',
    app_rate_2: '52.46%',
    avg_round_2: 30108,
    app_flat_2: 242,
    char_3: 'herta',
    app_rate_3: '45.21%',
    avg_round_3: 27841,
    app_flat_3: 290,
    char_4: 'firefly',
    app_rate_4: '19.57%',
    avg_round_4: 28447,
    app_flat_4: 40,
    char_5: 'the-herta',
    app_rate_5: '16.24%',
    avg_round_5: 34265,
    app_flat_5: 116,
    char_6: 'tribbie',
    app_rate_6: '15.74%',
    avg_round_6: 34472,
    app_flat_6: 94,
    char_7: 'aventurine',
    app_rate_7: '13.91%',
    avg_round_7: 25421,
    app_flat_7: 80,
    char_8: 'robin',
    app_rate_8: '13.66%',
    avg_round_8: 24013,
    app_flat_8: 76,
    char_9: 'lingsha',
    app_rate_9: '10.57%',
    avg_round_9: 29762,
    app_flat_9: 53,
    char_10: 'trailblazer-harmony',
    app_rate_10: '10.16%',
    avg_round_10: 33140,
    app_flat_10: 41,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '9.66%',
    avg_round_11: 31771,
    app_flat_11: 84,
    char_12: 'gallagher',
    app_rate_12: '7.83%',
    avg_round_12: 27474,
    app_flat_12: 55,
    char_13: 'rappa',
    app_rate_13: '4.66%',
    avg_round_13: 34422,
    app_flat_13: 41,
    char_14: 'fu-xuan',
    app_rate_14: '4.58%',
    avg_round_14: 29500,
    app_flat_14: 24,
    char_15: 'huohuo',
    app_rate_15: '3.58%',
    avg_round_15: 29322,
    app_flat_15: 22,
    char_16: 'acheron',
    app_rate_16: '2.66%',
    avg_round_16: 30091,
    app_flat_16: 11,
    char_17: 'jade',
    app_rate_17: '2.58%',
    avg_round_17: 32654,
    app_flat_17: 20,
    char_18: 'luocha',
    app_rate_18: '2.25%',
    avg_round_18: 24487,
    app_flat_18: 12,
    char_19: 'sparkle',
    app_rate_19: '1.33%',
    avg_round_19: 26013,
    app_flat_19: 6,
    char_20: 'sunday',
    app_rate_20: '1.25%',
    avg_round_20: 31124,
    app_flat_20: 9,
    char_21: 'serval',
    app_rate_21: '0.83%',
    avg_round_21: 26530,
    app_flat_21: 4,
    char_22: 'pela',
    app_rate_22: '0.5%',
    avg_round_22: 25710,
    app_flat_22: 4,
    char_23: 'kafka',
    app_rate_23: '0.25%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'mydei',
    app_rate_24: '0.25%',
    avg_round_24: 32467,
    app_flat_24: 3,
    char_25: 'yunli',
    app_rate_25: '0.25%',
    avg_round_25: 24340,
    app_flat_25: 2,
    char_26: 'xueyi',
    app_rate_26: '0.25%',
    avg_round_26: 24720,
    app_flat_26: 1,
    char_27: 'march-7th-swordmaster',
    app_rate_27: '0.17%',
    avg_round_27: 25040,
    app_flat_27: 1,
    char_28: 'feixiao',
    app_rate_28: '0.17%',
    avg_round_28: 23240,
    app_flat_28: 1,
    char_29: 'tingyun',
    app_rate_29: '0.17%',
    avg_round_29: 22200,
    app_flat_29: 1,
    char_30: 'argenti',
    app_rate_30: '0.17%',
    avg_round_30: 24200,
    app_flat_30: 1
  },
  {
    char: 'serval',
    app: 7.8,
    char_1: 'the-herta',
    app_rate_1: '86.58%',
    avg_round_1: 38676,
    app_flat_1: 516,
    char_2: 'tribbie',
    app_rate_2: '64.75%',
    avg_round_2: 39597,
    app_flat_2: 392,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '27.76%',
    avg_round_3: 34630,
    app_flat_3: 181,
    char_4: 'huohuo',
    app_rate_4: '19.0%',
    avg_round_4: 37540,
    app_flat_4: 108,
    char_5: 'aventurine',
    app_rate_5: '17.9%',
    avg_round_5: 38161,
    app_flat_5: 120,
    char_6: 'lingsha',
    app_rate_6: '15.98%',
    avg_round_6: 38679,
    app_flat_6: 101,
    char_7: 'gallagher',
    app_rate_7: '15.07%',
    avg_round_7: 36891,
    app_flat_7: 103,
    char_8: 'fu-xuan',
    app_rate_8: '11.96%',
    avg_round_8: 34427,
    app_flat_8: 64,
    char_9: 'robin',
    app_rate_9: '8.77%',
    avg_round_9: 29629,
    app_flat_9: 38,
    char_10: 'sunday',
    app_rate_10: '6.76%',
    avg_round_10: 30571,
    app_flat_10: 38,
    char_11: 'luocha',
    app_rate_11: '4.11%',
    avg_round_11: 34293,
    app_flat_11: 24,
    char_12: 'ruan-mei',
    app_rate_12: '4.02%',
    avg_round_12: 31029,
    app_flat_12: 21,
    char_13: 'jade',
    app_rate_13: '3.56%',
    avg_round_13: 31315,
    app_flat_13: 22,
    char_14: 'herta',
    app_rate_14: '3.2%',
    avg_round_14: 31489,
    app_flat_14: 18,
    char_15: 'sparkle',
    app_rate_15: '1.55%',
    avg_round_15: 28456,
    app_flat_15: 5,
    char_16: 'acheron',
    app_rate_16: '1.46%',
    avg_round_16: 26910,
    app_flat_16: 4,
    char_17: 'tingyun',
    app_rate_17: '1.19%',
    avg_round_17: 26298,
    app_flat_17: 11,
    char_18: 'himeko',
    app_rate_18: '0.91%',
    avg_round_18: 26530,
    app_flat_18: 4,
    char_19: 'kafka',
    app_rate_19: '0.82%',
    avg_round_19: 24770,
    app_flat_19: 4,
    char_20: 'pela',
    app_rate_20: '0.82%',
    avg_round_20: 32630,
    app_flat_20: 4,
    char_21: 'tingyun-fugue',
    app_rate_21: '0.64%',
    avg_round_21: 26016,
    app_flat_21: 5,
    char_22: 'bronya',
    app_rate_22: '0.64%',
    avg_round_22: 26000,
    app_flat_22: 3,
    char_23: 'yunli',
    app_rate_23: '0.27%',
    avg_round_23: 29620,
    app_flat_23: 2,
    char_24: 'bailu',
    app_rate_24: '0.27%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'hanya',
    app_rate_25: '0.27%',
    avg_round_25: 25920,
    app_flat_25: 2,
    char_26: 'march-7th',
    app_rate_26: '0.27%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'gepard',
    app_rate_27: '0.18%',
    avg_round_27: 24160,
    app_flat_27: 1,
    char_28: 'xueyi',
    app_rate_28: '0.18%',
    avg_round_28: 35280,
    app_flat_28: 1,
    char_29: 'asta',
    app_rate_29: '0.18%',
    avg_round_29: 25920,
    app_flat_29: 2,
    char_30: 'lynx',
    app_rate_30: '0.18%',
    avg_round_30: 32920,
    app_flat_30: 2
  },
  {
    char: 'kafka',
    app: 6.8,
    char_1: 'acheron',
    app_rate_1: '77.49%',
    avg_round_1: 25191,
    app_flat_1: 303,
    char_2: 'black-swan',
    app_rate_2: '56.23%',
    avg_round_2: 24450,
    app_flat_2: 165,
    char_3: 'aventurine',
    app_rate_3: '25.34%',
    avg_round_3: 25930,
    app_flat_3: 109,
    char_4: 'fu-xuan',
    app_rate_4: '24.5%',
    avg_round_4: 24633,
    app_flat_4: 95,
    char_5: 'ruan-mei',
    app_rate_5: '15.81%',
    avg_round_5: 23353,
    app_flat_5: 24,
    char_6: 'huohuo',
    app_rate_6: '15.39%',
    avg_round_6: 24040,
    app_flat_6: 29,
    char_7: 'tribbie',
    app_rate_7: '14.76%',
    avg_round_7: 30695,
    app_flat_7: 34,
    char_8: 'gallagher',
    app_rate_8: '12.36%',
    avg_round_8: 25472,
    app_flat_8: 49,
    char_9: 'jiaoqiu',
    app_rate_9: '10.47%',
    avg_round_9: 28409,
    app_flat_9: 46,
    char_10: 'pela',
    app_rate_10: '9.42%',
    avg_round_10: 25544,
    app_flat_10: 59,
    char_11: 'robin',
    app_rate_11: '7.85%',
    avg_round_11: 25065,
    app_flat_11: 14,
    char_12: 'lingsha',
    app_rate_12: '5.97%',
    avg_round_12: 25880,
    app_flat_12: 18,
    char_13: 'luocha',
    app_rate_13: '3.46%',
    avg_round_13: 25227,
    app_flat_13: 12,
    char_14: 'sparkle',
    app_rate_14: '3.25%',
    avg_round_14: 23560,
    app_flat_14: 2,
    char_15: 'trailblazer-remembrance',
    app_rate_15: '2.83%',
    avg_round_15: 26004,
    app_flat_15: 10,
    char_16: 'tingyun-fugue',
    app_rate_16: '2.51%',
    avg_round_16: 24713,
    app_flat_16: 12,
    char_17: 'gepard',
    app_rate_17: '2.2%',
    avg_round_17: 25043,
    app_flat_17: 12,
    char_18: 'jade',
    app_rate_18: '2.09%',
    avg_round_18: 30309,
    app_flat_18: 7,
    char_19: 'bailu',
    app_rate_19: '1.36%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'serval',
    app_rate_20: '0.94%',
    avg_round_20: 24770,
    app_flat_20: 4,
    char_21: 'silver-wolf',
    app_rate_21: '0.84%',
    avg_round_21: 23053,
    app_flat_21: 5,
    char_22: 'sunday',
    app_rate_22: '0.73%',
    avg_round_22: 25160,
    app_flat_22: 3,
    char_23: 'herta',
    app_rate_23: '0.63%',
    avg_round_23: 26220,
    app_flat_23: 2,
    char_24: 'tingyun',
    app_rate_24: '0.52%',
    avg_round_24: 24000,
    app_flat_24: 1,
    char_25: 'march-7th',
    app_rate_25: '0.52%',
    avg_round_25: 26147,
    app_flat_25: 3,
    char_26: 'bronya',
    app_rate_26: '0.42%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'himeko',
    app_rate_27: '0.31%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'guinaifen',
    app_rate_28: '0.31%',
    avg_round_28: 24040,
    app_flat_28: 1,
    char_29: 'aglaea',
    app_rate_29: '0.31%',
    avg_round_29: 25180,
    app_flat_29: 2,
    char_30: 'yunli',
    app_rate_30: '0.21%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'argenti',
    app: 5.19,
    char_1: 'tribbie',
    app_rate_1: '47.12%',
    avg_round_1: 39636,
    app_flat_1: 174,
    char_2: 'the-herta',
    app_rate_2: '35.16%',
    avg_round_2: 39754,
    app_flat_2: 134,
    char_3: 'sunday',
    app_rate_3: '31.32%',
    avg_round_3: 32071,
    app_flat_3: 107,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '31.18%',
    avg_round_4: 34156,
    app_flat_4: 137,
    char_5: 'huohuo',
    app_rate_5: '24.18%',
    avg_round_5: 34524,
    app_flat_5: 88,
    char_6: 'robin',
    app_rate_6: '22.66%',
    avg_round_6: 32617,
    app_flat_6: 62,
    char_7: 'aventurine',
    app_rate_7: '17.03%',
    avg_round_7: 33962,
    app_flat_7: 58,
    char_8: 'sparkle',
    app_rate_8: '12.64%',
    avg_round_8: 30458,
    app_flat_8: 48,
    char_9: 'tingyun',
    app_rate_9: '11.81%',
    avg_round_9: 29827,
    app_flat_9: 53,
    char_10: 'ruan-mei',
    app_rate_10: '9.48%',
    avg_round_10: 31159,
    app_flat_10: 41,
    char_11: 'gallagher',
    app_rate_11: '9.07%',
    avg_round_11: 39513,
    app_flat_11: 45,
    char_12: 'jade',
    app_rate_12: '8.65%',
    avg_round_12: 37870,
    app_flat_12: 30,
    char_13: 'herta',
    app_rate_13: '8.24%',
    avg_round_13: 30969,
    app_flat_13: 36,
    char_14: 'fu-xuan',
    app_rate_14: '7.83%',
    avg_round_14: 34584,
    app_flat_14: 32,
    char_15: 'luocha',
    app_rate_15: '7.69%',
    avg_round_15: 31183,
    app_flat_15: 28,
    char_16: 'lingsha',
    app_rate_16: '7.55%',
    avg_round_16: 39320,
    app_flat_16: 28,
    char_17: 'jiaoqiu',
    app_rate_17: '2.06%',
    avg_round_17: 27960,
    app_flat_17: 2,
    char_18: 'tingyun-fugue',
    app_rate_18: '1.65%',
    avg_round_18: 29620,
    app_flat_18: 6,
    char_19: 'bronya',
    app_rate_19: '1.51%',
    avg_round_19: 28720,
    app_flat_19: 8,
    char_20: 'mydei',
    app_rate_20: '0.55%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'bailu',
    app_rate_21: '0.41%',
    avg_round_21: 32280,
    app_flat_21: 2,
    char_22: 'yunli',
    app_rate_22: '0.41%',
    avg_round_22: 24000,
    app_flat_22: 1,
    char_23: 'himeko',
    app_rate_23: '0.27%',
    avg_round_23: 24200,
    app_flat_23: 1,
    char_24: 'blade',
    app_rate_24: '0.14%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'trailblazer-harmony',
    app_rate_25: '0.14%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'feixiao',
    app_rate_26: '0.14%',
    avg_round_26: 39680,
    app_flat_26: 1,
    char_27: 'acheron',
    app_rate_27: '0.14%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'lynx',
    app_rate_28: '0.14%',
    avg_round_28: 30560,
    app_flat_28: 1,
    char_29: 'xueyi',
    app_rate_29: '0.14%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'pela',
    app_rate_30: '0.14%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'black-swan',
    app: 5.18,
    char_1: 'acheron',
    app_rate_1: '77.17%',
    avg_round_1: 24477,
    app_flat_1: 220,
    char_2: 'kafka',
    app_rate_2: '73.87%',
    avg_round_2: 24450,
    app_flat_2: 165,
    char_3: 'aventurine',
    app_rate_3: '28.75%',
    avg_round_3: 25936,
    app_flat_3: 87,
    char_4: 'fu-xuan',
    app_rate_4: '20.91%',
    avg_round_4: 24210,
    app_flat_4: 56,
    char_5: 'huohuo',
    app_rate_5: '17.06%',
    avg_round_5: 23324,
    app_flat_5: 21,
    char_6: 'ruan-mei',
    app_rate_6: '16.64%',
    avg_round_6: 22698,
    app_flat_6: 13,
    char_7: 'gallagher',
    app_rate_7: '12.52%',
    avg_round_7: 24343,
    app_flat_7: 35,
    char_8: 'jiaoqiu',
    app_rate_8: '11.0%',
    avg_round_8: 26486,
    app_flat_8: 40,
    char_9: 'tribbie',
    app_rate_9: '8.53%',
    avg_round_9: 28499,
    app_flat_9: 15,
    char_10: 'robin',
    app_rate_10: '7.57%',
    avg_round_10: 23592,
    app_flat_10: 10,
    char_11: 'pela',
    app_rate_11: '6.6%',
    avg_round_11: 23056,
    app_flat_11: 22,
    char_12: 'lingsha',
    app_rate_12: '5.36%',
    avg_round_12: 24978,
    app_flat_12: 13,
    char_13: 'luocha',
    app_rate_13: '3.03%',
    avg_round_13: 24364,
    app_flat_13: 9,
    char_14: 'gepard',
    app_rate_14: '2.48%',
    avg_round_14: 23980,
    app_flat_14: 10,
    char_15: 'sparkle',
    app_rate_15: '2.2%',
    avg_round_15: 20860,
    app_flat_15: 2,
    char_16: 'bailu',
    app_rate_16: '1.38%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'trailblazer-remembrance',
    app_rate_17: '0.96%',
    avg_round_17: 21760,
    app_flat_17: 1,
    char_18: 'tingyun-fugue',
    app_rate_18: '0.69%',
    avg_round_18: 23560,
    app_flat_18: 3,
    char_19: 'sunday',
    app_rate_19: '0.55%',
    avg_round_19: 20440,
    app_flat_19: 1,
    char_20: 'herta',
    app_rate_20: '0.55%',
    avg_round_20: 24120,
    app_flat_20: 1,
    char_21: 'jade',
    app_rate_21: '0.41%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'guinaifen',
    app_rate_22: '0.28%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'tingyun',
    app_rate_23: '0.28%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'march-7th',
    app_rate_24: '0.28%',
    avg_round_24: 27480,
    app_flat_24: 1,
    char_25: 'hanya',
    app_rate_25: '0.14%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'himeko',
    app_rate_26: '0.14%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'sampo',
    app_rate_27: '0.14%',
    avg_round_27: 22920,
    app_flat_27: 1,
    char_28: 'the-herta',
    app_rate_28: '0.14%',
    avg_round_28: 21760,
    app_flat_28: 1,
    char_29: 'silver-wolf',
    app_rate_29: '0.14%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'clara',
    app_rate_30: '0.14%',
    avg_round_30: 23040,
    app_flat_30: 1
  },
  {
    char: 'yunli',
    app: 4.54,
    char_1: 'robin',
    app_rate_1: '62.32%',
    avg_round_1: 30376,
    app_flat_1: 155,
    char_2: 'tribbie',
    app_rate_2: '50.08%',
    avg_round_2: 36996,
    app_flat_2: 125,
    char_3: 'huohuo',
    app_rate_3: '37.36%',
    avg_round_3: 31132,
    app_flat_3: 90,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '20.72%',
    avg_round_4: 30356,
    app_flat_4: 62,
    char_5: 'sunday',
    app_rate_5: '20.25%',
    avg_round_5: 26690,
    app_flat_5: 43,
    char_6: 'aventurine',
    app_rate_6: '17.27%',
    avg_round_6: 31231,
    app_flat_6: 42,
    char_7: 'sparkle',
    app_rate_7: '13.66%',
    avg_round_7: 29872,
    app_flat_7: 24,
    char_8: 'fu-xuan',
    app_rate_8: '10.99%',
    avg_round_8: 32067,
    app_flat_8: 30,
    char_9: 'herta',
    app_rate_9: '10.2%',
    avg_round_9: 30793,
    app_flat_9: 27,
    char_10: 'tingyun',
    app_rate_10: '10.05%',
    avg_round_10: 26446,
    app_flat_10: 25,
    char_11: 'jade',
    app_rate_11: '9.42%',
    avg_round_11: 38288,
    app_flat_11: 30,
    char_12: 'luocha',
    app_rate_12: '5.65%',
    avg_round_12: 29278,
    app_flat_12: 19,
    char_13: 'lingsha',
    app_rate_13: '5.65%',
    avg_round_13: 32556,
    app_flat_13: 20,
    char_14: 'ruan-mei',
    app_rate_14: '3.3%',
    avg_round_14: 24624,
    app_flat_14: 9,
    char_15: 'gallagher',
    app_rate_15: '3.3%',
    avg_round_15: 31606,
    app_flat_15: 7,
    char_16: 'feixiao',
    app_rate_16: '3.14%',
    avg_round_16: 27991,
    app_flat_16: 9,
    char_17: 'clara',
    app_rate_17: '2.51%',
    avg_round_17: 25160,
    app_flat_17: 9,
    char_18: 'lynx',
    app_rate_18: '2.04%',
    avg_round_18: 26811,
    app_flat_18: 11,
    char_19: 'acheron',
    app_rate_19: '1.88%',
    avg_round_19: 26053,
    app_flat_19: 3,
    char_20: 'topaz',
    app_rate_20: '1.41%',
    avg_round_20: 30740,
    app_flat_20: 2,
    char_21: 'the-herta',
    app_rate_21: '1.1%',
    avg_round_21: 31800,
    app_flat_21: 4,
    char_22: 'tingyun-fugue',
    app_rate_22: '0.78%',
    avg_round_22: 24000,
    app_flat_22: 1,
    char_23: 'blade',
    app_rate_23: '0.78%',
    avg_round_23: 27040,
    app_flat_23: 2,
    char_24: 'march-7th-swordmaster',
    app_rate_24: '0.78%',
    avg_round_24: 25800,
    app_flat_24: 3,
    char_25: 'aglaea',
    app_rate_25: '0.63%',
    avg_round_25: 26680,
    app_flat_25: 1,
    char_26: 'serval',
    app_rate_26: '0.47%',
    avg_round_26: 29620,
    app_flat_26: 2,
    char_27: 'himeko',
    app_rate_27: '0.47%',
    avg_round_27: 24340,
    app_flat_27: 2,
    char_28: 'pela',
    app_rate_28: '0.47%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'jiaoqiu',
    app_rate_29: '0.47%',
    avg_round_29: 27080,
    app_flat_29: 1,
    char_30: 'argenti',
    app_rate_30: '0.47%',
    avg_round_30: 24000,
    app_flat_30: 1
  },
  {
    char: 'mydei',
    app: 3.45,
    char_1: 'sunday',
    app_rate_1: '67.15%',
    avg_round_1: 26770,
    app_flat_1: 106,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '55.58%',
    avg_round_2: 29229,
    app_flat_2: 88,
    char_3: 'tribbie',
    app_rate_3: '38.84%',
    avg_round_3: 31650,
    app_flat_3: 59,
    char_4: 'luocha',
    app_rate_4: '31.2%',
    avg_round_4: 24705,
    app_flat_4: 42,
    char_5: 'ruan-mei',
    app_rate_5: '21.49%',
    avg_round_5: 27764,
    app_flat_5: 28,
    char_6: 'bronya',
    app_rate_6: '16.74%',
    avg_round_6: 28163,
    app_flat_6: 26,
    char_7: 'sparkle',
    app_rate_7: '14.67%',
    avg_round_7: 24380,
    app_flat_7: 20,
    char_8: 'gallagher',
    app_rate_8: '12.6%',
    avg_round_8: 25263,
    app_flat_8: 11,
    char_9: 'herta',
    app_rate_9: '9.5%',
    avg_round_9: 32247,
    app_flat_9: 17,
    char_10: 'jiaoqiu',
    app_rate_10: '8.06%',
    avg_round_10: 27900,
    app_flat_10: 6,
    char_11: 'huohuo',
    app_rate_11: '6.61%',
    avg_round_11: 24360,
    app_flat_11: 11,
    char_12: 'robin',
    app_rate_12: '4.96%',
    avg_round_12: 26291,
    app_flat_12: 7,
    char_13: 'lingsha',
    app_rate_13: '2.07%',
    avg_round_13: 27176,
    app_flat_13: 5,
    char_14: 'pela',
    app_rate_14: '1.86%',
    avg_round_14: 25230,
    app_flat_14: 6,
    char_15: 'jade',
    app_rate_15: '1.65%',
    avg_round_15: 27427,
    app_flat_15: 3,
    char_16: 'lynx',
    app_rate_16: '1.45%',
    avg_round_16: 22890,
    app_flat_16: 4,
    char_17: 'the-herta',
    app_rate_17: '1.03%',
    avg_round_17: 36893,
    app_flat_17: 3,
    char_18: 'argenti',
    app_rate_18: '0.83%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'himeko',
    app_rate_19: '0.62%',
    avg_round_19: 32467,
    app_flat_19: 3,
    char_20: 'bailu',
    app_rate_20: '0.41%',
    avg_round_20: 25880,
    app_flat_20: 1,
    char_21: 'tingyun',
    app_rate_21: '0.41%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'rappa',
    app_rate_22: '0.21%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'trailblazer-harmony',
    app_rate_23: '0.21%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'aventurine',
    app_rate_24: '0.21%',
    avg_round_24: 27240,
    app_flat_24: 1,
    char_25: 'firefly',
    app_rate_25: '0.21%',
    avg_round_25: 21200,
    app_flat_25: 1,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '0.21%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'yunli',
    app_rate_27: '0.21%',
    avg_round_27: 26040,
    app_flat_27: 1,
    char_28: 'jing-yuan',
    app_rate_28: '0.21%',
    avg_round_28: 22040,
    app_flat_28: 1,
    char_29: 'acheron',
    app_rate_29: '0.21%',
    avg_round_29: 33720,
    app_flat_29: 1,
    char_30: 'arlan',
    app_rate_30: '0.21%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'bronya',
    app: 3.44,
    char_1: 'sunday',
    app_rate_1: '34.16%',
    avg_round_1: 30925,
    app_flat_1: 53,
    char_2: 'aglaea',
    app_rate_2: '27.54%',
    avg_round_2: 31268,
    app_flat_2: 39,
    char_3: 'acheron',
    app_rate_3: '25.88%',
    avg_round_3: 25560,
    app_flat_3: 2,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '22.36%',
    avg_round_4: 30304,
    app_flat_4: 42,
    char_5: 'robin',
    app_rate_5: '18.84%',
    avg_round_5: 29318,
    app_flat_5: 25,
    char_6: 'mydei',
    app_rate_6: '16.77%',
    avg_round_6: 28163,
    app_flat_6: 26,
    char_7: 'tribbie',
    app_rate_7: '14.91%',
    avg_round_7: 30141,
    app_flat_7: 23,
    char_8: 'jiaoqiu',
    app_rate_8: '14.7%',
    avg_round_8: 26490,
    app_flat_8: 4,
    char_9: 'aventurine',
    app_rate_9: '12.42%',
    avg_round_9: 25953,
    app_flat_9: 6,
    char_10: 'ruan-mei',
    app_rate_10: '12.01%',
    avg_round_10: 29671,
    app_flat_10: 17,
    char_11: 'pela',
    app_rate_11: '9.52%',
    avg_round_11: 24080,
    app_flat_11: 1,
    char_12: 'gallagher',
    app_rate_12: '8.9%',
    avg_round_12: 25320,
    app_flat_12: 8,
    char_13: 'herta',
    app_rate_13: '8.49%',
    avg_round_13: 26702,
    app_flat_13: 19,
    char_14: 'fu-xuan',
    app_rate_14: '8.07%',
    avg_round_14: 25260,
    app_flat_14: 4,
    char_15: 'luocha',
    app_rate_15: '6.83%',
    avg_round_15: 24600,
    app_flat_15: 9,
    char_16: 'huohuo',
    app_rate_16: '6.83%',
    avg_round_16: 26953,
    app_flat_16: 10,
    char_17: 'lingsha',
    app_rate_17: '6.63%',
    avg_round_17: 33777,
    app_flat_17: 7,
    char_18: 'sparkle',
    app_rate_18: '6.42%',
    avg_round_18: 24728,
    app_flat_18: 7,
    char_19: 'tingyun-fugue',
    app_rate_19: '4.97%',
    avg_round_19: 32750,
    app_flat_19: 8,
    char_20: 'jade',
    app_rate_20: '4.35%',
    avg_round_20: 34580,
    app_flat_20: 8,
    char_21: 'jing-yuan',
    app_rate_21: '3.73%',
    avg_round_21: 22653,
    app_flat_21: 6,
    char_22: 'the-herta',
    app_rate_22: '3.11%',
    avg_round_22: 30800,
    app_flat_22: 2,
    char_23: 'blade',
    app_rate_23: '3.11%',
    avg_round_23: 25100,
    app_flat_23: 4,
    char_24: 'firefly',
    app_rate_24: '2.9%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'rappa',
    app_rate_25: '2.69%',
    avg_round_25: 31836,
    app_flat_25: 9,
    char_26: 'argenti',
    app_rate_26: '2.28%',
    avg_round_26: 28720,
    app_flat_26: 8,
    char_27: 'trailblazer-harmony',
    app_rate_27: '1.86%',
    avg_round_27: 29573,
    app_flat_27: 3,
    char_28: 'jingliu',
    app_rate_28: '1.66%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'serval',
    app_rate_29: '1.45%',
    avg_round_29: 26000,
    app_flat_29: 3,
    char_30: 'tingyun',
    app_rate_30: '1.45%',
    avg_round_30: 24060,
    app_flat_30: 2
  },
  {
    char: 'feixiao',
    app: 3.13,
    char_1: 'robin',
    app_rate_1: '82.73%',
    avg_round_1: 27957,
    app_flat_1: 105,
    char_2: 'aventurine',
    app_rate_2: '53.86%',
    avg_round_2: 25756,
    app_flat_2: 56,
    char_3: 'herta',
    app_rate_3: '44.32%',
    avg_round_3: 29157,
    app_flat_3: 66,
    char_4: 'tribbie',
    app_rate_4: '29.09%',
    avg_round_4: 33555,
    app_flat_4: 42,
    char_5: 'jade',
    app_rate_5: '15.91%',
    avg_round_5: 32573,
    app_flat_5: 6,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '15.68%',
    avg_round_6: 30556,
    app_flat_6: 28,
    char_7: 'topaz',
    app_rate_7: '11.59%',
    avg_round_7: 24840,
    app_flat_7: 5,
    char_8: 'march-7th-swordmaster',
    app_rate_8: '10.23%',
    avg_round_8: 24343,
    app_flat_8: 22,
    char_9: 'lingsha',
    app_rate_9: '6.82%',
    avg_round_9: 33905,
    app_flat_9: 8,
    char_10: 'fu-xuan',
    app_rate_10: '5.23%',
    avg_round_10: 29160,
    app_flat_10: 10,
    char_11: 'gallagher',
    app_rate_11: '5.0%',
    avg_round_11: 25420,
    app_flat_11: 10,
    char_12: 'yunli',
    app_rate_12: '4.55%',
    avg_round_12: 27991,
    app_flat_12: 9,
    char_13: 'huohuo',
    app_rate_13: '2.73%',
    avg_round_13: 26760,
    app_flat_13: 3,
    char_14: 'ruan-mei',
    app_rate_14: '2.5%',
    avg_round_14: 30440,
    app_flat_14: 1,
    char_15: 'moze',
    app_rate_15: '2.05%',
    avg_round_15: 22480,
    app_flat_15: 2,
    char_16: 'clara',
    app_rate_16: '1.59%',
    avg_round_16: 26853,
    app_flat_16: 3,
    char_17: 'sunday',
    app_rate_17: '1.14%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'acheron',
    app_rate_18: '0.91%',
    avg_round_18: 24960,
    app_flat_18: 1,
    char_19: 'sparkle',
    app_rate_19: '0.68%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'luocha',
    app_rate_20: '0.68%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'himeko',
    app_rate_21: '0.45%',
    avg_round_21: 23240,
    app_flat_21: 1,
    char_22: 'dr-ratio',
    app_rate_22: '0.45%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'bronya',
    app_rate_23: '0.45%',
    avg_round_23: 21520,
    app_flat_23: 1,
    char_24: 'the-herta',
    app_rate_24: '0.23%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'argenti',
    app_rate_25: '0.23%',
    avg_round_25: 39680,
    app_flat_25: 1,
    char_26: 'aglaea',
    app_rate_26: '0.23%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'serval',
    app_rate_27: '0.23%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'lynx',
    app_rate_28: '0.23%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'blade',
    app_rate_29: '0.23%',
    avg_round_29: 33400,
    app_flat_29: 1,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'tingyun',
    app: 2.37,
    char_1: 'sunday',
    app_rate_1: '27.11%',
    avg_round_1: 26988,
    app_flat_1: 37,
    char_2: 'argenti',
    app_rate_2: '25.9%',
    avg_round_2: 29827,
    app_flat_2: 53,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '25.9%',
    avg_round_3: 30119,
    app_flat_3: 54,
    char_4: 'huohuo',
    app_rate_4: '22.59%',
    avg_round_4: 28155,
    app_flat_4: 31,
    char_5: 'yunli',
    app_rate_5: '19.28%',
    avg_round_5: 26446,
    app_flat_5: 25,
    char_6: 'robin',
    app_rate_6: '18.07%',
    avg_round_6: 25514,
    app_flat_6: 28,
    char_7: 'sparkle',
    app_rate_7: '17.77%',
    avg_round_7: 27328,
    app_flat_7: 20,
    char_8: 'tribbie',
    app_rate_8: '16.27%',
    avg_round_8: 34337,
    app_flat_8: 23,
    char_9: 'herta',
    app_rate_9: '15.66%',
    avg_round_9: 29811,
    app_flat_9: 33,
    char_10: 'jing-yuan',
    app_rate_10: '14.76%',
    avg_round_10: 26302,
    app_flat_10: 18,
    char_11: 'aventurine',
    app_rate_11: '13.55%',
    avg_round_11: 26278,
    app_flat_11: 18,
    char_12: 'fu-xuan',
    app_rate_12: '12.35%',
    avg_round_12: 24855,
    app_flat_12: 16,
    char_13: 'ruan-mei',
    app_rate_13: '11.45%',
    avg_round_13: 28561,
    app_flat_13: 28,
    char_14: 'gallagher',
    app_rate_14: '8.13%',
    avg_round_14: 25542,
    app_flat_14: 17,
    char_15: 'luocha',
    app_rate_15: '6.93%',
    avg_round_15: 28920,
    app_flat_15: 12,
    char_16: 'jade',
    app_rate_16: '6.63%',
    avg_round_16: 34144,
    app_flat_16: 10,
    char_17: 'lingsha',
    app_rate_17: '4.52%',
    avg_round_17: 31686,
    app_flat_17: 7,
    char_18: 'imbibitor-lunae',
    app_rate_18: '4.22%',
    avg_round_18: 23160,
    app_flat_18: 2,
    char_19: 'aglaea',
    app_rate_19: '3.92%',
    avg_round_19: 23048,
    app_flat_19: 5,
    char_20: 'serval',
    app_rate_20: '3.92%',
    avg_round_20: 26298,
    app_flat_20: 11,
    char_21: 'the-herta',
    app_rate_21: '3.61%',
    avg_round_21: 36407,
    app_flat_21: 6,
    char_22: 'bronya',
    app_rate_22: '2.11%',
    avg_round_22: 24060,
    app_flat_22: 2,
    char_23: 'pela',
    app_rate_23: '1.51%',
    avg_round_23: 31933,
    app_flat_23: 3,
    char_24: 'kafka',
    app_rate_24: '1.51%',
    avg_round_24: 24000,
    app_flat_24: 1,
    char_25: 'jiaoqiu',
    app_rate_25: '1.51%',
    avg_round_25: 33780,
    app_flat_25: 2,
    char_26: 'clara',
    app_rate_26: '1.2%',
    avg_round_26: 22973,
    app_flat_26: 3,
    char_27: 'acheron',
    app_rate_27: '1.2%',
    avg_round_27: 31760,
    app_flat_27: 3,
    char_28: 'rappa',
    app_rate_28: '1.2%',
    avg_round_28: 29820,
    app_flat_28: 2,
    char_29: 'tingyun-fugue',
    app_rate_29: '1.2%',
    avg_round_29: 29820,
    app_flat_29: 2,
    char_30: 'seele',
    app_rate_30: '1.2%',
    avg_round_30: 23000,
    app_flat_30: 1
  },
  {
    char: 'silver-wolf',
    app: 1.18,
    char_1: 'acheron',
    app_rate_1: '96.39%',
    avg_round_1: 23981,
    app_flat_1: 64,
    char_2: 'pela',
    app_rate_2: '40.36%',
    avg_round_2: 23384,
    app_flat_2: 42,
    char_3: 'fu-xuan',
    app_rate_3: '39.16%',
    avg_round_3: 23640,
    app_flat_3: 22,
    char_4: 'aventurine',
    app_rate_4: '31.33%',
    avg_round_4: 24443,
    app_flat_4: 23,
    char_5: 'jiaoqiu',
    app_rate_5: '19.28%',
    avg_round_5: 26929,
    app_flat_5: 14,
    char_6: 'sparkle',
    app_rate_6: '13.86%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'tribbie',
    app_rate_7: '12.05%',
    avg_round_7: 31040,
    app_flat_7: 4,
    char_8: 'gallagher',
    app_rate_8: '9.64%',
    avg_round_8: 23422,
    app_flat_8: 9,
    char_9: 'kafka',
    app_rate_9: '4.82%',
    avg_round_9: 23053,
    app_flat_9: 5,
    char_10: 'lingsha',
    app_rate_10: '4.82%',
    avg_round_10: 23920,
    app_flat_10: 4,
    char_11: 'gepard',
    app_rate_11: '4.22%',
    avg_round_11: 24040,
    app_flat_11: 1,
    char_12: 'robin',
    app_rate_12: '3.01%',
    avg_round_12: 21080,
    app_flat_12: 1,
    char_13: 'bronya',
    app_rate_13: '2.41%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '2.41%',
    avg_round_14: 24160,
    app_flat_14: 1,
    char_15: 'jade',
    app_rate_15: '1.81%',
    avg_round_15: 26000,
    app_flat_15: 1,
    char_16: 'herta',
    app_rate_16: '1.81%',
    avg_round_16: 23600,
    app_flat_16: 1,
    char_17: 'tingyun-fugue',
    app_rate_17: '1.81%',
    avg_round_17: 28560,
    app_flat_17: 1,
    char_18: 'sunday',
    app_rate_18: '1.81%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'the-herta',
    app_rate_19: '1.2%',
    avg_round_19: 40000,
    app_flat_19: 1,
    char_20: 'ruan-mei',
    app_rate_20: '1.2%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'huohuo',
    app_rate_21: '1.2%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'luocha',
    app_rate_22: '1.2%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'serval',
    app_rate_23: '0.6%',
    avg_round_23: 40000,
    app_flat_23: 1,
    char_24: 'march-7th-swordmaster',
    app_rate_24: '0.6%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'trailblazer-preservation',
    app_rate_25: '0.6%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'qingque',
    app_rate_26: '0.6%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'black-swan',
    app_rate_27: '0.6%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'clara',
    app_rate_28: '0.6%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'aglaea',
    app_rate_29: '0.6%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'clara',
    app: 1.15,
    char_1: 'robin',
    app_rate_1: '69.75%',
    avg_round_1: 26366,
    app_flat_1: 51,
    char_2: 'tribbie',
    app_rate_2: '38.27%',
    avg_round_2: 31381,
    app_flat_2: 23,
    char_3: 'aventurine',
    app_rate_3: '35.19%',
    avg_round_3: 27001,
    app_flat_3: 27,
    char_4: 'fu-xuan',
    app_rate_4: '19.75%',
    avg_round_4: 27916,
    app_flat_4: 11,
    char_5: 'herta',
    app_rate_5: '19.14%',
    avg_round_5: 29000,
    app_flat_5: 10,
    char_6: 'huohuo',
    app_rate_6: '16.05%',
    avg_round_6: 25480,
    app_flat_6: 10,
    char_7: 'sparkle',
    app_rate_7: '15.43%',
    avg_round_7: 25200,
    app_flat_7: 9,
    char_8: 'jade',
    app_rate_8: '14.2%',
    avg_round_8: 31391,
    app_flat_8: 13,
    char_9: 'sunday',
    app_rate_9: '12.96%',
    avg_round_9: 28390,
    app_flat_9: 8,
    char_10: 'yunli',
    app_rate_10: '9.88%',
    avg_round_10: 25160,
    app_flat_10: 9,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '9.26%',
    avg_round_11: 27293,
    app_flat_11: 6,
    char_12: 'lingsha',
    app_rate_12: '7.41%',
    avg_round_12: 27360,
    app_flat_12: 5,
    char_13: 'luocha',
    app_rate_13: '6.79%',
    avg_round_13: 24368,
    app_flat_13: 5,
    char_14: 'feixiao',
    app_rate_14: '4.32%',
    avg_round_14: 26853,
    app_flat_14: 3,
    char_15: 'ruan-mei',
    app_rate_15: '3.09%',
    avg_round_15: 35600,
    app_flat_15: 1,
    char_16: 'tingyun',
    app_rate_16: '2.47%',
    avg_round_16: 22973,
    app_flat_16: 3,
    char_17: 'topaz',
    app_rate_17: '2.47%',
    avg_round_17: 21627,
    app_flat_17: 3,
    char_18: 'gallagher',
    app_rate_18: '2.47%',
    avg_round_18: 33120,
    app_flat_18: 2,
    char_19: 'acheron',
    app_rate_19: '1.85%',
    avg_round_19: 24700,
    app_flat_19: 2,
    char_20: 'jiaoqiu',
    app_rate_20: '1.23%',
    avg_round_20: 24080,
    app_flat_20: 1,
    char_21: 'jing-yuan',
    app_rate_21: '1.23%',
    avg_round_21: 25280,
    app_flat_21: 2,
    char_22: 'the-herta',
    app_rate_22: '1.23%',
    avg_round_22: 35520,
    app_flat_22: 1,
    char_23: 'aglaea',
    app_rate_23: '0.62%',
    avg_round_23: 33280,
    app_flat_23: 1,
    char_24: 'jingliu',
    app_rate_24: '0.62%',
    avg_round_24: 24040,
    app_flat_24: 1,
    char_25: 'serval',
    app_rate_25: '0.62%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'black-swan',
    app_rate_26: '0.62%',
    avg_round_26: 23040,
    app_flat_26: 1,
    char_27: 'argenti',
    app_rate_27: '0.62%',
    avg_round_27: 25520,
    app_flat_27: 1,
    char_28: 'lynx',
    app_rate_28: '0.62%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'dr-ratio',
    app_rate_29: '0.62%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'silver-wolf',
    app_rate_30: '0.62%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'imbibitor-lunae',
    app: 1.03,
    char_1: 'sparkle',
    app_rate_1: '57.93%',
    avg_round_1: 22350,
    app_flat_1: 4,
    char_2: 'sunday',
    app_rate_2: '55.86%',
    avg_round_2: 23740,
    app_flat_2: 2,
    char_3: 'robin',
    app_rate_3: '32.41%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'ruan-mei',
    app_rate_4: '24.14%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'huohuo',
    app_rate_5: '23.45%',
    avg_round_5: 22960,
    app_flat_5: 1,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '22.76%',
    avg_round_6: 22060,
    app_flat_6: 2,
    char_7: 'luocha',
    app_rate_7: '17.93%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'aventurine',
    app_rate_8: '15.86%',
    avg_round_8: 22320,
    app_flat_8: 1,
    char_9: 'tribbie',
    app_rate_9: '13.1%',
    avg_round_9: 22960,
    app_flat_9: 1,
    char_10: 'tingyun',
    app_rate_10: '9.66%',
    avg_round_10: 23160,
    app_flat_10: 2,
    char_11: 'gallagher',
    app_rate_11: '7.59%',
    avg_round_11: 24000,
    app_flat_11: 1,
    char_12: 'herta',
    app_rate_12: '7.59%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'fu-xuan',
    app_rate_13: '3.45%',
    avg_round_13: 20640,
    app_flat_13: 1,
    char_14: 'jiaoqiu',
    app_rate_14: '2.76%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'lingsha',
    app_rate_15: '1.38%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'march-7th-swordmaster',
    app_rate_16: '0.69%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'trailblazer-harmony',
    app_rate_17: '0.69%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'hanya',
    app_rate_18: '0.69%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'lynx',
    app_rate_19: '0.69%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'jing-yuan',
    app_rate_20: '0.69%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'blade',
    app_rate_21: '0.69%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'blade',
    app: 0.83,
    char_1: 'jade',
    app_rate_1: '51.72%',
    avg_round_1: 33793,
    app_flat_1: 22,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 35208,
    app_flat_2: 21,
    char_3: 'sunday',
    app_rate_3: '28.45%',
    avg_round_3: 31889,
    app_flat_3: 9,
    char_4: 'fu-xuan',
    app_rate_4: '23.28%',
    avg_round_4: 36728,
    app_flat_4: 7,
    char_5: 'robin',
    app_rate_5: '19.83%',
    avg_round_5: 29120,
    app_flat_5: 6,
    char_6: 'luocha',
    app_rate_6: '18.1%',
    avg_round_6: 26130,
    app_flat_6: 8,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '16.38%',
    avg_round_7: 25300,
    app_flat_7: 8,
    char_8: 'ruan-mei',
    app_rate_8: '12.93%',
    avg_round_8: 26253,
    app_flat_8: 3,
    char_9: 'bronya',
    app_rate_9: '12.93%',
    avg_round_9: 25100,
    app_flat_9: 4,
    char_10: 'huohuo',
    app_rate_10: '12.07%',
    avg_round_10: 33920,
    app_flat_10: 1,
    char_11: 'gallagher',
    app_rate_11: '9.48%',
    avg_round_11: 37520,
    app_flat_11: 4,
    char_12: 'lingsha',
    app_rate_12: '7.76%',
    avg_round_12: 35384,
    app_flat_12: 5,
    char_13: 'lynx',
    app_rate_13: '6.9%',
    avg_round_13: 27080,
    app_flat_13: 1,
    char_14: 'herta',
    app_rate_14: '6.03%',
    avg_round_14: 26693,
    app_flat_14: 3,
    char_15: 'sparkle',
    app_rate_15: '6.03%',
    avg_round_15: 32280,
    app_flat_15: 1,
    char_16: 'jingliu',
    app_rate_16: '4.31%',
    avg_round_16: 24160,
    app_flat_16: 1,
    char_17: 'yunli',
    app_rate_17: '4.31%',
    avg_round_17: 27040,
    app_flat_17: 2,
    char_18: 'jiaoqiu',
    app_rate_18: '1.72%',
    avg_round_18: 26600,
    app_flat_18: 1,
    char_19: 'acheron',
    app_rate_19: '0.86%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'argenti',
    app_rate_20: '0.86%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'xueyi',
    app_rate_21: '0.86%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'jing-yuan',
    app_rate_22: '0.86%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'imbibitor-lunae',
    app_rate_23: '0.86%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'bailu',
    app_rate_24: '0.86%',
    avg_round_24: 26000,
    app_flat_24: 1,
    char_25: 'feixiao',
    app_rate_25: '0.86%',
    avg_round_25: 33400,
    app_flat_25: 1,
    char_26: 'the-herta',
    app_rate_26: '0.86%',
    avg_round_26: 24000,
    app_flat_26: 1,
    char_27: 'aventurine',
    app_rate_27: '0.86%',
    avg_round_27: 24000,
    app_flat_27: 1,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'gepard',
    app: 0.73,
    char_1: 'acheron',
    app_rate_1: '85.44%',
    avg_round_1: 24584,
    app_flat_1: 27,
    char_2: 'pela',
    app_rate_2: '39.81%',
    avg_round_2: 24369,
    app_flat_2: 13,
    char_3: 'jiaoqiu',
    app_rate_3: '22.33%',
    avg_round_3: 26720,
    app_flat_3: 8,
    char_4: 'kafka',
    app_rate_4: '20.39%',
    avg_round_4: 25043,
    app_flat_4: 12,
    char_5: 'sparkle',
    app_rate_5: '19.42%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'black-swan',
    app_rate_6: '17.48%',
    avg_round_6: 23980,
    app_flat_6: 10,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '11.65%',
    avg_round_7: 29167,
    app_flat_7: 6,
    char_8: 'sunday',
    app_rate_8: '11.65%',
    avg_round_8: 26370,
    app_flat_8: 4,
    char_9: 'herta',
    app_rate_9: '8.74%',
    avg_round_9: 31126,
    app_flat_9: 7,
    char_10: 'the-herta',
    app_rate_10: '7.77%',
    avg_round_10: 31008,
    app_flat_10: 5,
    char_11: 'tribbie',
    app_rate_11: '7.77%',
    avg_round_11: 35520,
    app_flat_11: 1,
    char_12: 'tingyun-fugue',
    app_rate_12: '7.77%',
    avg_round_12: 23920,
    app_flat_12: 4,
    char_13: 'silver-wolf',
    app_rate_13: '6.8%',
    avg_round_13: 24040,
    app_flat_13: 1,
    char_14: 'jade',
    app_rate_14: '6.8%',
    avg_round_14: 29230,
    app_flat_14: 4,
    char_15: 'bronya',
    app_rate_15: '6.8%',
    avg_round_15: 21960,
    app_flat_15: 1,
    char_16: 'robin',
    app_rate_16: '6.8%',
    avg_round_16: 31187,
    app_flat_16: 3,
    char_17: 'aglaea',
    app_rate_17: '2.91%',
    avg_round_17: 26867,
    app_flat_17: 3,
    char_18: 'serval',
    app_rate_18: '1.94%',
    avg_round_18: 24160,
    app_flat_18: 1,
    char_19: 'jing-yuan',
    app_rate_19: '1.94%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'ruan-mei',
    app_rate_20: '1.94%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'himeko',
    app_rate_21: '0.97%',
    avg_round_21: 28080,
    app_flat_21: 1,
    char_22: 'march-7th-swordmaster',
    app_rate_22: '0.97%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'guinaifen',
    app_rate_23: '0.97%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'firefly',
    app_rate_24: '0.97%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'bailu',
    app: 0.57,
    char_1: 'sunday',
    app_rate_1: '35.0%',
    avg_round_1: 26753,
    app_flat_1: 12,
    char_2: 'robin',
    app_rate_2: '31.25%',
    avg_round_2: 32260,
    app_flat_2: 8,
    char_3: 'the-herta',
    app_rate_3: '28.75%',
    avg_round_3: 37996,
    app_flat_3: 9,
    char_4: 'tribbie',
    app_rate_4: '25.0%',
    avg_round_4: 37650,
    app_flat_4: 8,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '23.75%',
    avg_round_5: 32200,
    app_flat_5: 9,
    char_6: 'aglaea',
    app_rate_6: '20.0%',
    avg_round_6: 31270,
    app_flat_6: 4,
    char_7: 'herta',
    app_rate_7: '18.75%',
    avg_round_7: 37333,
    app_flat_7: 10,
    char_8: 'jade',
    app_rate_8: '17.5%',
    avg_round_8: 37093,
    app_flat_8: 5,
    char_9: 'kafka',
    app_rate_9: '16.25%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'jing-yuan',
    app_rate_10: '13.75%',
    avg_round_10: 26120,
    app_flat_10: 7,
    char_11: 'black-swan',
    app_rate_11: '12.5%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'acheron',
    app_rate_12: '12.5%',
    avg_round_12: 21480,
    app_flat_12: 1,
    char_13: 'ruan-mei',
    app_rate_13: '6.25%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'bronya',
    app_rate_14: '5.0%',
    avg_round_14: 26000,
    app_flat_14: 1,
    char_15: 'jiaoqiu',
    app_rate_15: '5.0%',
    avg_round_15: 21480,
    app_flat_15: 1,
    char_16: 'sparkle',
    app_rate_16: '3.75%',
    avg_round_16: 25920,
    app_flat_16: 1,
    char_17: 'argenti',
    app_rate_17: '3.75%',
    avg_round_17: 32280,
    app_flat_17: 2,
    char_18: 'tingyun',
    app_rate_18: '3.75%',
    avg_round_18: 28080,
    app_flat_18: 1,
    char_19: 'serval',
    app_rate_19: '3.75%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'mydei',
    app_rate_20: '2.5%',
    avg_round_20: 25880,
    app_flat_20: 1,
    char_21: 'rappa',
    app_rate_21: '2.5%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'yunli',
    app_rate_22: '2.5%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'qingque',
    app_rate_23: '1.25%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'pela',
    app_rate_24: '1.25%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'tingyun-fugue',
    app_rate_25: '1.25%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'himeko',
    app_rate_26: '1.25%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'blade',
    app_rate_27: '1.25%',
    avg_round_27: 26000,
    app_flat_27: 1,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'topaz',
    app: 0.56,
    char_1: 'robin',
    app_rate_1: '76.92%',
    avg_round_1: 24025,
    app_flat_1: 8,
    char_2: 'aventurine',
    app_rate_2: '69.23%',
    avg_round_2: 24496,
    app_flat_2: 10,
    char_3: 'feixiao',
    app_rate_3: '65.38%',
    avg_round_3: 24840,
    app_flat_3: 5,
    char_4: 'tribbie',
    app_rate_4: '21.79%',
    avg_round_4: 27008,
    app_flat_4: 5,
    char_5: 'yunli',
    app_rate_5: '11.54%',
    avg_round_5: 30740,
    app_flat_5: 2,
    char_6: 'lingsha',
    app_rate_6: '10.26%',
    avg_round_6: 20840,
    app_flat_6: 1,
    char_7: 'herta',
    app_rate_7: '8.97%',
    avg_round_7: 24320,
    app_flat_7: 1,
    char_8: 'huohuo',
    app_rate_8: '6.41%',
    avg_round_8: 31600,
    app_flat_8: 1,
    char_9: 'jade',
    app_rate_9: '5.13%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'clara',
    app_rate_10: '5.13%',
    avg_round_10: 21627,
    app_flat_10: 3,
    char_11: 'jiaoqiu',
    app_rate_11: '3.85%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'acheron',
    app_rate_12: '2.56%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'luocha',
    app_rate_13: '2.56%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '2.56%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'sparkle',
    app_rate_15: '2.56%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'fu-xuan',
    app_rate_16: '1.28%',
    avg_round_16: 26000,
    app_flat_16: 1,
    char_17: 'the-herta',
    app_rate_17: '1.28%',
    avg_round_17: 20840,
    app_flat_17: 1,
    char_18: 'himeko',
    app_rate_18: '1.28%',
    avg_round_18: 20840,
    app_flat_18: 1,
    char_19: 'aglaea',
    app_rate_19: '1.28%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th-swordmaster',
    app: 0.56,
    char_1: 'robin',
    app_rate_1: '70.89%',
    avg_round_1: 24014,
    app_flat_1: 28,
    char_2: 'feixiao',
    app_rate_2: '56.96%',
    avg_round_2: 24343,
    app_flat_2: 22,
    char_3: 'aventurine',
    app_rate_3: '39.24%',
    avg_round_3: 23880,
    app_flat_3: 16,
    char_4: 'tribbie',
    app_rate_4: '22.78%',
    avg_round_4: 28240,
    app_flat_4: 6,
    char_5: 'herta',
    app_rate_5: '22.78%',
    avg_round_5: 24905,
    app_flat_5: 8,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '11.39%',
    avg_round_6: 23910,
    app_flat_6: 4,
    char_7: 'gallagher',
    app_rate_7: '10.13%',
    avg_round_7: 25253,
    app_flat_7: 5,
    char_8: 'fu-xuan',
    app_rate_8: '10.13%',
    avg_round_8: 26520,
    app_flat_8: 2,
    char_9: 'ruan-mei',
    app_rate_9: '7.59%',
    avg_round_9: 25030,
    app_flat_9: 4,
    char_10: 'yunli',
    app_rate_10: '6.33%',
    avg_round_10: 25800,
    app_flat_10: 3,
    char_11: 'huohuo',
    app_rate_11: '6.33%',
    avg_round_11: 24627,
    app_flat_11: 3,
    char_12: 'lingsha',
    app_rate_12: '5.06%',
    avg_round_12: 25560,
    app_flat_12: 1,
    char_13: 'tingyun-fugue',
    app_rate_13: '3.8%',
    avg_round_13: 25000,
    app_flat_13: 2,
    char_14: 'firefly',
    app_rate_14: '3.8%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'himeko',
    app_rate_15: '2.53%',
    avg_round_15: 25040,
    app_flat_15: 1,
    char_16: 'trailblazer-harmony',
    app_rate_16: '2.53%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'rappa',
    app_rate_17: '2.53%',
    avg_round_17: 24960,
    app_flat_17: 1,
    char_18: 'jade',
    app_rate_18: '2.53%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'sparkle',
    app_rate_19: '1.27%',
    avg_round_19: 26040,
    app_flat_19: 1,
    char_20: 'acheron',
    app_rate_20: '1.27%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'silver-wolf',
    app_rate_21: '1.27%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'gepard',
    app_rate_22: '1.27%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'imbibitor-lunae',
    app_rate_23: '1.27%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'mydei',
    app_rate_24: '1.27%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'luocha',
    app_rate_25: '1.27%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'pela',
    app_rate_26: '1.27%',
    avg_round_26: 28720,
    app_flat_26: 1,
    char_27: 'tingyun',
    app_rate_27: '1.27%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'the-herta',
    app_rate_28: '1.27%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lynx',
    app: 0.45,
    char_1: 'tribbie',
    app_rate_1: '38.1%',
    avg_round_1: 31411,
    app_flat_1: 11,
    char_2: 'jade',
    app_rate_2: '33.33%',
    avg_round_2: 34240,
    app_flat_2: 10,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '30.16%',
    avg_round_3: 26940,
    app_flat_3: 8,
    char_4: 'sunday',
    app_rate_4: '28.57%',
    avg_round_4: 24432,
    app_flat_4: 9,
    char_5: 'the-herta',
    app_rate_5: '20.63%',
    avg_round_5: 38504,
    app_flat_5: 7,
    char_6: 'yunli',
    app_rate_6: '20.63%',
    avg_round_6: 26811,
    app_flat_6: 11,
    char_7: 'robin',
    app_rate_7: '15.87%',
    avg_round_7: 24680,
    app_flat_7: 5,
    char_8: 'sparkle',
    app_rate_8: '14.29%',
    avg_round_8: 22590,
    app_flat_8: 6,
    char_9: 'blade',
    app_rate_9: '12.7%',
    avg_round_9: 27080,
    app_flat_9: 1,
    char_10: 'herta',
    app_rate_10: '12.7%',
    avg_round_10: 35180,
    app_flat_10: 2,
    char_11: 'ruan-mei',
    app_rate_11: '11.11%',
    avg_round_11: 28470,
    app_flat_11: 4,
    char_12: 'mydei',
    app_rate_12: '11.11%',
    avg_round_12: 22890,
    app_flat_12: 4,
    char_13: 'aglaea',
    app_rate_13: '9.52%',
    avg_round_13: 26160,
    app_flat_13: 2,
    char_14: 'acheron',
    app_rate_14: '4.76%',
    avg_round_14: 24040,
    app_flat_14: 1,
    char_15: 'bronya',
    app_rate_15: '4.76%',
    avg_round_15: 24400,
    app_flat_15: 1,
    char_16: 'tingyun',
    app_rate_16: '4.76%',
    avg_round_16: 24733,
    app_flat_16: 3,
    char_17: 'jiaoqiu',
    app_rate_17: '3.17%',
    avg_round_17: 24040,
    app_flat_17: 1,
    char_18: 'jing-yuan',
    app_rate_18: '3.17%',
    avg_round_18: 24640,
    app_flat_18: 1,
    char_19: 'serval',
    app_rate_19: '3.17%',
    avg_round_19: 32920,
    app_flat_19: 2,
    char_20: 'kafka',
    app_rate_20: '1.59%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'jingliu',
    app_rate_21: '1.59%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'argenti',
    app_rate_22: '1.59%',
    avg_round_22: 30560,
    app_flat_22: 1,
    char_23: 'xueyi',
    app_rate_23: '1.59%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'trailblazer-harmony',
    app_rate_24: '1.59%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'asta',
    app_rate_25: '1.59%',
    avg_round_25: 27920,
    app_flat_25: 1,
    char_26: 'imbibitor-lunae',
    app_rate_26: '1.59%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'qingque',
    app_rate_27: '1.59%',
    avg_round_27: 20840,
    app_flat_27: 1,
    char_28: 'clara',
    app_rate_28: '1.59%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'feixiao',
    app_rate_29: '1.59%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'black-swan',
    app_rate_30: '1.59%',
    avg_round_30: 24040,
    app_flat_30: 1
  },
  {
    char: 'qingque',
    app: 0.43,
    char_1: 'sparkle',
    app_rate_1: '86.67%',
    avg_round_1: 23280,
    app_flat_1: 14,
    char_2: 'fu-xuan',
    app_rate_2: '65.0%',
    avg_round_2: 24080,
    app_flat_2: 7,
    char_3: 'tribbie',
    app_rate_3: '58.33%',
    avg_round_3: 28995,
    app_flat_3: 8,
    char_4: 'sunday',
    app_rate_4: '20.0%',
    avg_round_4: 24368,
    app_flat_4: 7,
    char_5: 'jade',
    app_rate_5: '8.33%',
    avg_round_5: 25040,
    app_flat_5: 3,
    char_6: 'robin',
    app_rate_6: '8.33%',
    avg_round_6: 26520,
    app_flat_6: 2,
    char_7: 'huohuo',
    app_rate_7: '8.33%',
    avg_round_7: 27227,
    app_flat_7: 3,
    char_8: 'the-herta',
    app_rate_8: '6.67%',
    avg_round_8: 36000,
    app_flat_8: 2,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '6.67%',
    avg_round_9: 22960,
    app_flat_9: 1,
    char_10: 'lingsha',
    app_rate_10: '5.0%',
    avg_round_10: 32800,
    app_flat_10: 1,
    char_11: 'aventurine',
    app_rate_11: '5.0%',
    avg_round_11: 29300,
    app_flat_11: 2,
    char_12: 'gallagher',
    app_rate_12: '3.33%',
    avg_round_12: 24120,
    app_flat_12: 2,
    char_13: 'herta',
    app_rate_13: '3.33%',
    avg_round_13: 35040,
    app_flat_13: 1,
    char_14: 'ruan-mei',
    app_rate_14: '3.33%',
    avg_round_14: 29360,
    app_flat_14: 1,
    char_15: 'pela',
    app_rate_15: '1.67%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'bailu',
    app_rate_16: '1.67%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tingyun',
    app_rate_17: '1.67%',
    avg_round_17: 21880,
    app_flat_17: 1,
    char_18: 'silver-wolf',
    app_rate_18: '1.67%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'seele',
    app_rate_19: '1.67%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'argenti',
    app_rate_20: '1.67%',
    avg_round_20: 34200,
    app_flat_20: 1,
    char_21: 'lynx',
    app_rate_21: '1.67%',
    avg_round_21: 20840,
    app_flat_21: 1,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'seele',
    app: 0.32,
    char_1: 'sparkle',
    app_rate_1: '53.33%',
    avg_round_1: 25360,
    app_flat_1: 1,
    char_2: 'fu-xuan',
    app_rate_2: '51.11%',
    avg_round_2: 29880,
    app_flat_2: 3,
    char_3: 'tribbie',
    app_rate_3: '44.44%',
    avg_round_3: 31230,
    app_flat_3: 4,
    char_4: 'robin',
    app_rate_4: '42.22%',
    avg_round_4: 24280,
    app_flat_4: 1,
    char_5: 'sunday',
    app_rate_5: '20.0%',
    avg_round_5: 23000,
    app_flat_5: 1,
    char_6: 'herta',
    app_rate_6: '20.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '13.33%',
    avg_round_7: 35280,
    app_flat_7: 1,
    char_8: 'gallagher',
    app_rate_8: '8.89%',
    avg_round_8: 27453,
    app_flat_8: 3,
    char_9: 'jade',
    app_rate_9: '8.89%',
    avg_round_9: 40000,
    app_flat_9: 1,
    char_10: 'tingyun',
    app_rate_10: '8.89%',
    avg_round_10: 23000,
    app_flat_10: 1,
    char_11: 'bronya',
    app_rate_11: '4.44%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'aventurine',
    app_rate_12: '4.44%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'acheron',
    app_rate_13: '2.22%',
    avg_round_13: 24080,
    app_flat_13: 1,
    char_14: 'tingyun-fugue',
    app_rate_14: '2.22%',
    avg_round_14: 24080,
    app_flat_14: 1,
    char_15: 'yunli',
    app_rate_15: '2.22%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'serval',
    app_rate_16: '2.22%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'kafka',
    app_rate_17: '2.22%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'qingque',
    app_rate_18: '2.22%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'luocha',
    app_rate_19: '2.22%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'rappa',
    app_rate_20: '2.22%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'huohuo',
    app_rate_21: '2.22%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jingliu',
    app: 0.31,
    char_1: 'tribbie',
    app_rate_1: '36.36%',
    avg_round_1: 25880,
    app_flat_1: 2,
    char_2: 'ruan-mei',
    app_rate_2: '34.09%',
    avg_round_2: 24100,
    app_flat_2: 4,
    char_3: 'sunday',
    app_rate_3: '29.55%',
    avg_round_3: 24120,
    app_flat_3: 2,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '27.27%',
    avg_round_4: 24480,
    app_flat_4: 4,
    char_5: 'robin',
    app_rate_5: '27.27%',
    avg_round_5: 24140,
    app_flat_5: 2,
    char_6: 'fu-xuan',
    app_rate_6: '20.45%',
    avg_round_6: 25880,
    app_flat_6: 2,
    char_7: 'herta',
    app_rate_7: '18.18%',
    avg_round_7: 25133,
    app_flat_7: 3,
    char_8: 'huohuo',
    app_rate_8: '18.18%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'bronya',
    app_rate_9: '18.18%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'blade',
    app_rate_10: '11.36%',
    avg_round_10: 24160,
    app_flat_10: 1,
    char_11: 'luocha',
    app_rate_11: '9.09%',
    avg_round_11: 22640,
    app_flat_11: 1,
    char_12: 'lingsha',
    app_rate_12: '9.09%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'the-herta',
    app_rate_13: '6.82%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'aventurine',
    app_rate_14: '4.55%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'gallagher',
    app_rate_15: '4.55%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'sparkle',
    app_rate_16: '4.55%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'rappa',
    app_rate_17: '2.27%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'jade',
    app_rate_18: '2.27%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'lynx',
    app_rate_19: '2.27%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'clara',
    app_rate_20: '2.27%',
    avg_round_20: 24040,
    app_flat_20: 1,
    char_21: 'firefly',
    app_rate_21: '2.27%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'serval',
    app_rate_22: '2.27%',
    avg_round_22: 27720,
    app_flat_22: 1,
    char_23: 'tingyun-fugue',
    app_rate_23: '2.27%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'mydei',
    app_rate_24: '2.27%',
    avg_round_24: 22640,
    app_flat_24: 1,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'xueyi',
    app: 0.28,
    char_1: 'tribbie',
    app_rate_1: '57.5%',
    avg_round_1: 33560,
    app_flat_1: 8,
    char_2: 'fu-xuan',
    app_rate_2: '35.0%',
    avg_round_2: 29720,
    app_flat_2: 2,
    char_3: 'tingyun-fugue',
    app_rate_3: '32.5%',
    avg_round_3: 25440,
    app_flat_3: 4,
    char_4: 'ruan-mei',
    app_rate_4: '32.5%',
    avg_round_4: 24350,
    app_flat_4: 4,
    char_5: 'sparkle',
    app_rate_5: '20.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '17.5%',
    avg_round_6: 32944,
    app_flat_6: 5,
    char_7: 'jade',
    app_rate_7: '15.0%',
    avg_round_7: 28920,
    app_flat_7: 1,
    char_8: 'robin',
    app_rate_8: '15.0%',
    avg_round_8: 39500,
    app_flat_8: 2,
    char_9: 'lingsha',
    app_rate_9: '15.0%',
    avg_round_9: 26240,
    app_flat_9: 2,
    char_10: 'aventurine',
    app_rate_10: '12.5%',
    avg_round_10: 35240,
    app_flat_10: 2,
    char_11: 'himeko',
    app_rate_11: '7.5%',
    avg_round_11: 24720,
    app_flat_11: 1,
    char_12: 'gallagher',
    app_rate_12: '7.5%',
    avg_round_12: 20640,
    app_flat_12: 1,
    char_13: 'serval',
    app_rate_13: '5.0%',
    avg_round_13: 35280,
    app_flat_13: 1,
    char_14: 'herta',
    app_rate_14: '5.0%',
    avg_round_14: 40000,
    app_flat_14: 1,
    char_15: 'trailblazer-harmony',
    app_rate_15: '2.5%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'luocha',
    app_rate_16: '2.5%',
    avg_round_16: 24280,
    app_flat_16: 1,
    char_17: 'the-herta',
    app_rate_17: '2.5%',
    avg_round_17: 35280,
    app_flat_17: 1,
    char_18: 'lynx',
    app_rate_18: '2.5%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'blade',
    app_rate_19: '2.5%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'argenti',
    app_rate_20: '2.5%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'jing-yuan',
    app_rate_21: '2.5%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'bronya',
    app_rate_22: '2.5%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'huohuo',
    app_rate_23: '2.5%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th',
    app: 0.19,
    char_1: 'acheron',
    app_rate_1: '51.85%',
    avg_round_1: 27330,
    app_flat_1: 4,
    char_2: 'tribbie',
    app_rate_2: '40.74%',
    avg_round_2: 36960,
    app_flat_2: 3,
    char_3: 'herta',
    app_rate_3: '37.04%',
    avg_round_3: 32520,
    app_flat_3: 7,
    char_4: 'the-herta',
    app_rate_4: '29.63%',
    avg_round_4: 35352,
    app_flat_4: 5,
    char_5: 'pela',
    app_rate_5: '25.93%',
    avg_round_5: 30880,
    app_flat_5: 1,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '22.22%',
    avg_round_6: 35352,
    app_flat_6: 5,
    char_7: 'kafka',
    app_rate_7: '18.52%',
    avg_round_7: 26147,
    app_flat_7: 3,
    char_8: 'ruan-mei',
    app_rate_8: '14.81%',
    avg_round_8: 25440,
    app_flat_8: 2,
    char_9: 'serval',
    app_rate_9: '11.11%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'jiaoqiu',
    app_rate_10: '7.41%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'black-swan',
    app_rate_11: '7.41%',
    avg_round_11: 27480,
    app_flat_11: 1,
    char_12: 'jade',
    app_rate_12: '7.41%',
    avg_round_12: 32080,
    app_flat_12: 2,
    char_13: 'robin',
    app_rate_13: '7.41%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'tingyun',
    app_rate_14: '3.7%',
    avg_round_14: 24000,
    app_flat_14: 1,
    char_15: 'rappa',
    app_rate_15: '3.7%',
    avg_round_15: 26720,
    app_flat_15: 1,
    char_16: 'tingyun-fugue',
    app_rate_16: '3.7%',
    avg_round_16: 26960,
    app_flat_16: 1,
    char_17: 'sunday',
    app_rate_17: '3.7%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'himeko',
    app_rate_18: '3.7%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'guinaifen',
    app: 0.14,
    char_1: 'acheron',
    app_rate_1: '85.0%',
    avg_round_1: 23977,
    app_flat_1: 14,
    char_2: 'pela',
    app_rate_2: '65.0%',
    avg_round_2: 23967,
    app_flat_2: 12,
    char_3: 'aventurine',
    app_rate_3: '60.0%',
    avg_round_3: 23907,
    app_flat_3: 9,
    char_4: 'gallagher',
    app_rate_4: '20.0%',
    avg_round_4: 24120,
    app_flat_4: 4,
    char_5: 'kafka',
    app_rate_5: '15.0%',
    avg_round_5: 24040,
    app_flat_5: 1,
    char_6: 'black-swan',
    app_rate_6: '10.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'tingyun-fugue',
    app_rate_7: '10.0%',
    avg_round_7: 24040,
    app_flat_7: 1,
    char_8: 'huohuo',
    app_rate_8: '5.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'fu-xuan',
    app_rate_9: '5.0%',
    avg_round_9: 24040,
    app_flat_9: 1,
    char_10: 'robin',
    app_rate_10: '5.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'gepard',
    app_rate_11: '5.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'firefly',
    app_rate_12: '5.0%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'lingsha',
    app_rate_13: '5.0%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'jiaoqiu',
    app_rate_14: '5.0%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'moze',
    app: 0.11,
    char_1: 'robin',
    app_rate_1: '66.67%',
    avg_round_1: 22480,
    app_flat_1: 2,
    char_2: 'feixiao',
    app_rate_2: '60.0%',
    avg_round_2: 22480,
    app_flat_2: 2,
    char_3: 'aventurine',
    app_rate_3: '60.0%',
    avg_round_3: 23560,
    app_flat_3: 1,
    char_4: 'tribbie',
    app_rate_4: '26.67%',
    avg_round_4: 24660,
    app_flat_4: 2,
    char_5: 'gallagher',
    app_rate_5: '13.33%',
    avg_round_5: 21400,
    app_flat_5: 1,
    char_6: 'huohuo',
    app_rate_6: '13.33%',
    avg_round_6: 24660,
    app_flat_6: 2,
    char_7: 'kafka',
    app_rate_7: '6.67%',
    avg_round_7: 22560,
    app_flat_7: 1,
    char_8: 'herta',
    app_rate_8: '6.67%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'ruan-mei',
    app_rate_9: '6.67%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'aglaea',
    app_rate_10: '6.67%',
    avg_round_10: 26200,
    app_flat_10: 1,
    char_11: 'sunday',
    app_rate_11: '6.67%',
    avg_round_11: 26200,
    app_flat_11: 1,
    char_12: 'fu-xuan',
    app_rate_12: '6.67%',
    avg_round_12: 26200,
    app_flat_12: 1,
    char_13: 'yunli',
    app_rate_13: '6.67%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'jade',
    app_rate_14: '6.67%',
    avg_round_14: 26760,
    app_flat_14: 1,
    char_15: 'dr-ratio',
    app_rate_15: '6.67%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'asta',
    app: 0.08,
    char_1: 'sunday',
    app_rate_1: '36.36%',
    avg_round_1: 28740,
    app_flat_1: 4,
    char_2: 'the-herta',
    app_rate_2: '27.27%',
    avg_round_2: 25520,
    app_flat_2: 1,
    char_3: 'lingsha',
    app_rate_3: '27.27%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'aglaea',
    app_rate_4: '27.27%',
    avg_round_4: 28580,
    app_flat_4: 2,
    char_5: 'herta',
    app_rate_5: '27.27%',
    avg_round_5: 27880,
    app_flat_5: 2,
    char_6: 'jade',
    app_rate_6: '18.18%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '18.18%',
    avg_round_7: 28900,
    app_flat_7: 2,
    char_8: 'robin',
    app_rate_8: '18.18%',
    avg_round_8: 27560,
    app_flat_8: 1,
    char_9: 'serval',
    app_rate_9: '18.18%',
    avg_round_9: 25920,
    app_flat_9: 2,
    char_10: 'hanya',
    app_rate_10: '18.18%',
    avg_round_10: 25920,
    app_flat_10: 2,
    char_11: 'gallagher',
    app_rate_11: '18.18%',
    avg_round_11: 25920,
    app_flat_11: 2,
    char_12: 'tribbie',
    app_rate_12: '9.09%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'huohuo',
    app_rate_13: '9.09%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'lynx',
    app_rate_14: '9.09%',
    avg_round_14: 27920,
    app_flat_14: 1,
    char_15: 'aventurine',
    app_rate_15: '9.09%',
    avg_round_15: 25520,
    app_flat_15: 1,
    char_16: 'luocha',
    app_rate_16: '9.09%',
    avg_round_16: 29240,
    app_flat_16: 1,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'boothill',
    app: 0.07,
    char_1: 'tingyun-fugue',
    app_rate_1: '90.0%',
    avg_round_1: 26800,
    app_flat_1: 2,
    char_2: 'ruan-mei',
    app_rate_2: '80.0%',
    avg_round_2: 20480,
    app_flat_2: 1,
    char_3: 'lingsha',
    app_rate_3: '40.0%',
    avg_round_3: 20480,
    app_flat_3: 1,
    char_4: 'sunday',
    app_rate_4: '30.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'pela',
    app_rate_5: '10.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'the-herta',
    app_rate_6: '10.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'herta',
    app_rate_7: '10.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'rappa',
    app_rate_8: '10.0%',
    avg_round_8: 33120,
    app_flat_8: 1,
    char_9: 'trailblazer-harmony',
    app_rate_9: '10.0%',
    avg_round_9: 33120,
    app_flat_9: 1,
    char_10: 'gallagher',
    app_rate_10: '10.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'welt',
    app: 0.07,
    char_1: 'acheron',
    app_rate_1: '70.0%',
    avg_round_1: 24240,
    app_flat_1: 1,
    char_2: 'ruan-mei',
    app_rate_2: '40.0%',
    avg_round_2: 25640,
    app_flat_2: 2,
    char_3: 'tribbie',
    app_rate_3: '30.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'aventurine',
    app_rate_4: '30.0%',
    avg_round_4: 24240,
    app_flat_4: 1,
    char_5: 'tingyun-fugue',
    app_rate_5: '20.0%',
    avg_round_5: 27280,
    app_flat_5: 1,
    char_6: 'pela',
    app_rate_6: '20.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'sparkle',
    app_rate_7: '20.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'jiaoqiu',
    app_rate_8: '20.0%',
    avg_round_8: 24240,
    app_flat_8: 1,
    char_9: 'herta',
    app_rate_9: '10.0%',
    avg_round_9: 27280,
    app_flat_9: 1,
    char_10: 'fu-xuan',
    app_rate_10: '10.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'himeko',
    app_rate_11: '10.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'rappa',
    app_rate_12: '10.0%',
    avg_round_12: 24000,
    app_flat_12: 1,
    char_13: 'trailblazer-harmony',
    app_rate_13: '10.0%',
    avg_round_13: 24000,
    app_flat_13: 1,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hanya',
    app: 0.07,
    char_1: 'sunday',
    app_rate_1: '50.0%',
    avg_round_1: 27053,
    app_flat_1: 3,
    char_2: 'herta',
    app_rate_2: '30.0%',
    avg_round_2: 30780,
    app_flat_2: 2,
    char_3: 'serval',
    app_rate_3: '30.0%',
    avg_round_3: 25920,
    app_flat_3: 2,
    char_4: 'pela',
    app_rate_4: '20.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'jing-yuan',
    app_rate_5: '20.0%',
    avg_round_5: 26180,
    app_flat_5: 2,
    char_6: 'fu-xuan',
    app_rate_6: '20.0%',
    avg_round_6: 26440,
    app_flat_6: 1,
    char_7: 'the-herta',
    app_rate_7: '20.0%',
    avg_round_7: 32760,
    app_flat_7: 1,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '20.0%',
    avg_round_8: 27360,
    app_flat_8: 2,
    char_9: 'asta',
    app_rate_9: '20.0%',
    avg_round_9: 25920,
    app_flat_9: 2,
    char_10: 'gallagher',
    app_rate_10: '20.0%',
    avg_round_10: 25920,
    app_flat_10: 2,
    char_11: 'acheron',
    app_rate_11: '10.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'black-swan',
    app_rate_12: '10.0%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'ruan-mei',
    app_rate_13: '10.0%',
    avg_round_13: 32760,
    app_flat_13: 1,
    char_14: 'imbibitor-lunae',
    app_rate_14: '10.0%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'argenti',
    app_rate_15: '10.0%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dr-ratio',
    app: 0.05,
    char_1: 'robin',
    app_rate_1: '85.71%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'aventurine',
    app_rate_2: '71.43%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'feixiao',
    app_rate_3: '28.57%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'tribbie',
    app_rate_4: '14.29%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'pela',
    app_rate_5: '14.29%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'gallagher',
    app_rate_6: '14.29%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'jiaoqiu',
    app_rate_7: '14.29%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'yunli',
    app_rate_8: '14.29%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'fu-xuan',
    app_rate_9: '14.29%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'clara',
    app_rate_10: '14.29%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'moze',
    app_rate_11: '14.29%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-preservation',
    app: 0.04,
    char_1: 'acheron',
    app_rate_1: '66.67%',
    avg_round_1: 24380,
    app_flat_1: 2,
    char_2: 'pela',
    app_rate_2: '50.0%',
    avg_round_2: 24380,
    app_flat_2: 2,
    char_3: 'sparkle',
    app_rate_3: '50.0%',
    avg_round_3: 23440,
    app_flat_3: 1,
    char_4: 'himeko',
    app_rate_4: '16.67%',
    avg_round_4: 25320,
    app_flat_4: 1,
    char_5: 'kafka',
    app_rate_5: '16.67%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'silver-wolf',
    app_rate_6: '16.67%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'herta',
    app_rate_7: '16.67%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'tribbie',
    app_rate_8: '16.67%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'jiaoqiu',
    app_rate_9: '16.67%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'yunli',
    app_rate_10: '16.67%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'tingyun',
    app_rate_11: '16.67%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'sampo',
    app: 0.04,
    char_1: 'acheron',
    app_rate_1: '66.67%',
    avg_round_1: 27900,
    app_flat_1: 2,
    char_2: 'aventurine',
    app_rate_2: '50.0%',
    avg_round_2: 25240,
    app_flat_2: 2,
    char_3: 'pela',
    app_rate_3: '50.0%',
    avg_round_3: 32880,
    app_flat_3: 1,
    char_4: 'tribbie',
    app_rate_4: '33.33%',
    avg_round_4: 32880,
    app_flat_4: 1,
    char_5: 'black-swan',
    app_rate_5: '16.67%',
    avg_round_5: 22920,
    app_flat_5: 1,
    char_6: 'luka',
    app_rate_6: '16.67%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'the-herta',
    app_rate_7: '16.67%',
    avg_round_7: 27560,
    app_flat_7: 1,
    char_8: 'herta',
    app_rate_8: '16.67%',
    avg_round_8: 27560,
    app_flat_8: 1,
    char_9: 'kafka',
    app_rate_9: '16.67%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'huohuo',
    app_rate_10: '16.67%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'natasha',
    app: 0.03,
    char_1: 'sunday',
    app_rate_1: '50.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'the-herta',
    app_rate_2: '25.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'jade',
    app_rate_3: '25.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'herta',
    app_rate_4: '25.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'firefly',
    app_rate_5: '25.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'himeko',
    app_rate_6: '25.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'tingyun-fugue',
    app_rate_7: '25.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'aglaea',
    app_rate_8: '25.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'tribbie',
    app_rate_9: '25.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'jing-yuan',
    app_rate_10: '25.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'tingyun',
    app_rate_11: '25.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'misha',
    app: 0.01,
    char_1: 'herta',
    app_rate_1: '50.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'robin',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'sparkle',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'sunday',
    app_rate_6: '50.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dan-heng',
    app: 0.01,
    char_1: 'the-herta',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'herta',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'tribbie',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'arlan',
    app: 0.01,
    char_1: 'mydei',
    app_rate_1: '50.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'luocha',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'firefly',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'tingyun-fugue',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'ruan-mei',
    app_rate_6: '50.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'luka',
    app: 0.01,
    char_1: 'sampo',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'pela',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'tribbie',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hook',
    app: 0.01,
    char_1: 'sparkle',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'fu-xuan',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  }
];
